/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });
    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = _.filter(this.instances, function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

$(document).ready(function () {
  $('ul.tabs').each(function () {
    var active,
      content,
      links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    $(this)
      .find('a')
      .click(function (e) {
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
  });
});

slate.rte = {
  wrapTable: function () {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function () {
    var $iframeVideo = $(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
    );
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function () {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  },
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $('a[href*=#]').on(
      'click',
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventName, function (evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})(@{1}?\d{1}?x{1}?)*[_\.]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size == null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function () {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function (variant) {
        return selectedValues.every(function (values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant,
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);

      //STOCK URGENCY START
      if (variant.inventory_management == 'shopify') {
        var stock = parseInt(
          $('.product-single-right option[value="' + variant.id + '"]').data(
            'stock'
          )
        );
        var maxqty = parseInt(
          $('.product-single-right .progress-content').data('quantity')
        );
        $('#variant-stock').html(stock);

        if (stock > 0 && stock <= maxqty) {
          $('.product-single-right .progress-content').removeClass('hide');
          switch (stock) {
            case 9:
              $('#binderpos-bar span').css('width', '65%');
              break;
            case 8:
              $('#binderpos-bar span').css('width', '60%');
              break;
            case 7:
              $('#binderpos-bar span').css('width', '55%');
              break;
            case 6:
              $('#binderpos-bar span').css('width', '50%');
              break;
            case 5:
              $('#binderpos-bar span').css('width', '45%');
              break;
            case 4:
              $('#binderpos-bar span').css('width', '30%');
              break;
            case 3:
              $('#binderpos-bar span').css('width', '20%');
              break;
            case 2:
              $('#binderpos-bar span').css('width', '10%');
              break;
            case 1:
              $('#binderpos-bar span').css('width', '5%');
              break;
            default:
              $('#binderpos-bar span').css('width', '90%');
          }
        } else {
          $('.product-single-right .progress-content').addClass('hide');
        }
      }
      //STOCK URGENCY END

      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant,
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function (variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    },
  });

  return Variants;
})();

/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function () {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position,
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContainer'),
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus',
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus',
    });

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function () {
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function (evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function () {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function () {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function () {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();

/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function () {
  var selectors = {
    body: 'body',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '.site-nav--has-dropdown',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last',
  };

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link',
  };

  var cache = {};

  function init() {
    cacheSelectors();

    //     cache.$parents.on('click.siteNav', function(evt) {
    //       var $el = $(this);

    //       if (!$el.hasClass(config.activeClass)) {
    // force stop the click from happening
    //         evt.preventDefault();
    //         evt.stopImmediatePropagation();
    //       }

    //       showDropdown($el);
    //     });

    // check when we're leaving a dropdown and close the active dropdown
    //     $(selectors.siteNavChildLink).on('focusout.siteNav', function() {
    //       setTimeout(function() {
    //         if ($(document.activeElement).hasClass(config.childLinkClass) || !cache.$activeDropdown.length) {
    //           return;
    //         }

    //         hideDropdown(cache.$activeDropdown);
    //       });
    //     });

    // close dropdowns when on top level nav
    //     cache.$topLevel.on('focus.siteNav', function() {
    //       if (cache.$activeDropdown.length) {
    //         hideDropdown(cache.$activeDropdown);
    //       }
    //     });

    //     cache.$subMenuLinks.on('click.siteNav', function(evt) {
    //       // Prevent click on body from firing instead of link
    //       evt.stopImmediatePropagation();
    //     });
  }

  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown),
    };
  }

  function showDropdown($el) {
    $el.addClass(config.activeClass);

    // close open dropdowns
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }

    cache.$activeDropdown = $el;

    // set expanded on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

    setTimeout(function () {
      $(window).on('keyup.siteNav', function (evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });

      $(selectors.body).on('click.siteNav', function () {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
    $el.removeClass(config.activeClass);

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }

  function unload() {
    $(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
  }

  return {
    init: init,
    unload: unload,
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function () {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu',
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;
  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  var mediaQuerySmall = 'screen and (max-width: 749px)';

  function init() {
    cacheSelectors();

    cache.$mobileNavToggle.on('click', toggleMobileNav);
    cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQuerySmall, {
      unmatch: function () {
        closeMobileNav();
      },
    });
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      $pageContainer: $('#PageContainer'),
      $siteHeader: $('.site-header'),
      $mobileNavToggle: $('.js-mobile-nav-toggle'),
      $mobileNavContainer: $('.mobile-nav-wrapper'),
      $mobileNav: $('#MobileNav'),
      $subNavToggleBtn: $('.' + classes.subNavToggleBtn),
    };
  }

  function openMobileNav() {
    var translateHeaderHeight =
      cache.$siteHeader.outerHeight() + cache.$siteHeader.offset().top;

    cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translate3d(0, ' + translateHeaderHeight + 'px, 0)',
    });
    cache.$pageContainer.css({
      transform:
        'translate3d(0, ' +
        cache.$mobileNavContainer[0].scrollHeight +
        'px, 0)',
    });

    slate.a11y.trapFocus({
      $container: cache.$mobileNav,
      namespace: 'navFocus',
    });

    cache.$mobileNavToggle
      .addClass(classes.mobileNavCloseIcon)
      .removeClass(classes.mobileNavOpenIcon);

    // close on escape
    $(window).on('keyup.mobileNav', function (evt) {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translate3d(0, -100%, 0)',
    });
    cache.$pageContainer.removeAttr('style');

    cache.$mobileNavContainer.one(
      'TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle',
      function () {
        slate.a11y.removeTrapFocus({
          $container: cache.$mobileNav,
          namespace: 'navFocus',
        });
      }
    );

    cache.$mobileNavToggle
      .addClass(classes.mobileNavOpenIcon)
      .removeClass(classes.mobileNavCloseIcon);

    $(window).off('keyup.mobileNav');
  }

  function toggleSubNav(evt) {
    if (isTransitioning) {
      return;
    }

    var $toggleBtn = $(evt.currentTarget);
    var isReturn = $toggleBtn.hasClass(classes.return);
    isTransitioning = true;

    if (isReturn) {
      // Close all subnavs by removing active class on buttons
      $(
        '.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
      ).removeClass(classes.subNavActive);

      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive);
      }
    } else {
      $toggleBtn.addClass(classes.subNavActive);
    }

    $activeTrigger = $toggleBtn;

    goToSubnav($toggleBtn.data('target'));
  }

  function goToSubnav(target) {
    /*eslint-disable shopify/jquery-dollar-sign-reference */

    var $targetMenu = target
      ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
      : cache.$mobileNav;

    menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;

    if ($activeSubNav && $activeSubNav.length) {
      $activeSubNav.prepareTransition().addClass(classes.subNavClosing);
    }

    $activeSubNav = $targetMenu;

    var $elementToFocus = target
      ? $targetMenu.find('.' + classes.subNavLink + ':first')
      : $activeTrigger;

    /*eslint-enable shopify/jquery-dollar-sign-reference */

    var translateMenuHeight = $targetMenu.outerHeight();

    var openNavClass =
      menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

    cache.$mobileNavContainer
      .css('height', translateMenuHeight)
      .removeClass(classes.thirdNavShowing)
      .addClass(openNavClass);

    if (!target) {
      // Show top level nav
      cache.$mobileNavContainer
        .removeClass(classes.thirdNavShowing)
        .removeClass(classes.subNavShowing);
    }

    // Focusing an item in the subnav early forces element into view and breaks the animation.
    cache.$mobileNavContainer.one(
      'TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle',
      function () {
        slate.a11y.trapFocus({
          $container: $targetMenu,
          $elementToFocus: $elementToFocus,
          namespace: 'subNavFocus',
        });

        cache.$mobileNavContainer.off('.subnavToggle');
        isTransitioning = false;
      }
    );

    // Match height of subnav
    cache.$pageContainer.css({
      transform: 'translate3d(0, ' + translateMenuHeight + 'px, 0)',
    });

    $activeSubNav.removeClass(classes.subNavClosing);
  }

  return {
    init: init,
    closeMobileNav: closeMobileNav,
  };
})(jQuery);

window.theme = window.theme || {};

theme.Search = (function () {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',

    searchDrawer: '.search-bar',
    searchDrawerInput: '.search-bar__input',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    mobileNavWrapper: '.mobile-nav-wrapper',
  };

  var classes = {
    focus: 'search--focus',
    mobileNavIsOpen: 'js-menu--is-open',
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    initDrawer();
    searchSubmit();

    $(selectors.searchHeaderInput)
      .add(selectors.searchHeaderSubmit)
      .on('focus blur', function () {
        $(selectors.searchHeader).toggleClass(classes.focus);
      });

    $(selectors.siteHeaderSearchToggle).on('click', function () {
      var searchHeight = $(selectors.siteHeader).outerHeight();
      var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;

      $(selectors.searchDrawer).css({
        height: searchHeight + 'px',
        top: searchOffset + 'px',
      });
    });
  }

  function initDrawer() {
    // Add required classes to HTML
    $('#PageContainer').addClass('drawer-page-content');
    $('.js-drawer-open-top')
      .attr('aria-controls', 'SearchDrawer')
      .attr('aria-expanded', 'false');

    theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: searchDrawerFocus,
    });
  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput));

    if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
      theme.MobileNav.closeMobileNav();
    }
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchSubmit() {
    $(selectors.searchSubmit).on('click', function (evt) {
      var $el = $(evt.target);
      var $input = $el.parents(selectors.search).find(selectors.searchInput);
      if ($input.val().length === 0) {
        evt.preventDefault();
        searchFocus($input);
      }
    });
  }

  return {
    init: init,
  };
})();

(function () {
  var selectors = {
    backButton: '.return-link',
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function (evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function () {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused',
  };

  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);

    this.settings = {
      accessibility: true,
      arrows: true,
      dots: true,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data('autoplay'),

      autoplaySpeed: this.$slideshow.data('speed'),
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function (evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function (evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function (evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if (evt.which === 37 || evt.which === 39) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find(
      '.slideshow__slide[data-slick-index="' + nextSlide + '"]'
    );

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }

  slideshow.prototype.togglePause = function () {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function () {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0,
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange,
    },
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    slideshowWrapper: 'slideshow-wrapper',
    slide: 'slideshow__slide',
    slideBackgroundVideo: 'slideshow__slide--background-video',
    slideDots: 'slick-dots',
    videoChrome: 'slideshow__video--chrome',
    videoBackground: 'slideshow__video--background',
    playVideoBtn: 'slideshow__video-control--play',
    closeVideoBtn: 'slideshow__video-control--close',
    currentSlide: 'slick-current',
    slickClone: 'slick-cloned',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay',
  };

  /**
   * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
      videoSelector: $video.attr('id'),
      $parentSlide: $video.closest('.' + classes.slide),
      $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
      controls: $video.data('type') === 'background' ? 0 : 1,
      slideshow: $video.data('slideshow'),
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === 'function'
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
      ? classes.supportsAutoplay
      : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
      .then(function () {
        setAutoplaySupport(true);
      })
      .fail(function () {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false);
        player.stopVideo();
      })
      .always(function () {
        autoplayCheckComplete = true;
        $slide.removeClass(classes.loading);
      });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function () {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function () {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (window.mobileCheck()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case 'background-chrome':
      case 'background':
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'background-chrome':
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case 'chrome':
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    switch (videoData.type) {
      case 'chrome':
      case 'background-chrome':
        $slideshow.removeClass(classes.paused).addClass(classes.playing);
        $slide.removeClass(classes.paused).addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find('.' + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === 'background-chrome') {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== 'closed' && videoData.type !== 'background') {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === 'chrome' && videoData.status === 'closed') {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(' ');

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'background-chrome':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case 'chrome':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = 'open';

    switch (videoData.type) {
      case 'background-chrome':
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case 'chrome':
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on('keydown.videoPlayer', function (evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.videoBackground).each(function (index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest('.' + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player
        .width(playerWidth)
        .height(playerHeight)
        .css({
          left: (slideWidth - playerWidth) / 2,
          top: 0,
        }); // player width is greater, offset left; reset top
    } else {
      // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player
        .width(slideWidth)
        .height(playerHeight)
        .css({
          left: 0,
          top: (playerHeight - playerHeight) / 2,
        }); // player height is greater, offset top; reset left
    }

    $player.prepareTransition().addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $('#' + playerId)
      .removeAttr('style')
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $('#' + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide.addClass(classes.slideBackgroundVideo);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on(
      'click.videoPlayer',
      '.' + classes.playVideoBtn,
      function (evt) {
        var playerId = $(evt.currentTarget).data('controls');
        startVideoOnClick(playerId);
      }
    );

    $(document).on(
      'click.videoPlayer',
      '.' + classes.closeVideoBtn,
      function (evt) {
        var playerId = $(evt.currentTarget).data('controls');
        closeVideo(playerId);
      }
    );

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on(
      'resize.videoPlayer',
      $.debounce(250, function () {
        if (youtubeLoaded) {
          sizeBackgroundVideos();
        }
      })
    );
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents,
  };
})();

/* ================ TEMPLATES ================ */
// (function() {
//   var $filterBy = $('#BlogTagFilter');

//   if (!$filterBy.length) {
//     return;
//   }

//   $filterBy.on('change', function() {
//     location.href = $(this).val();
//   });

// })();

window.theme = theme || {};

theme.customerTemplates = (function () {
  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function (evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function (evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew',
        }
      );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function () {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector,
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function () {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function () {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function () {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' },
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function () {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    },
  };
})();

/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function () {
  var selectors = {
    edit: '.js-edit-toggle',
  };
  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies',
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }

    this.$edit.on('click', this._onEditClick.bind(this));
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function () {
      this.$edit.off('click', this._onEditClick);
    },

    _onEditClick: function (evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));

      $evtTarget.toggleClass(config.showEditClass);
      $updateLine.toggleClass(config.showClass);
    },

    cookiesEnabled: function () {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    },
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function () {
  var constants = {
    SORT_BY: 'sort_by',
  };
  var selectors = {
    filterSelection: '.filters-toolbar__input--filter',
    sortSelection: '.filters-toolbar__input--sort',
    defaultSort: '.collection-header__default-sort',
  };

  function Filters(container) {
    var $container = (this.$container = $(container));

    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add(
      $(selectors.sortSelection, $container)
    );

    this.defaultSort = this._getDefaultSortValue();
    this._resizeSelect(this.$selects);
    this.$selects.removeClass('hidden');

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _onSortChange: function (evt) {
      var sort = this._sortValue();
      if (sort.length) {
        window.location.search = sort;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = window.location.href.replace(
          window.location.search,
          ''
        );
      }
      this._resizeSelect($(evt.target));
    },

    _onFilterChange: function (evt) {
      window.location.href = this.$filterSelect.val() + window.location.search;
      this._resizeSelect($(evt.target));
    },

    _getSortValue: function () {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function () {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function () {
      var sort = this._getSortValue();
      var query = '';

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }

      return query;
    },

    _resizeSelect: function ($selection) {
      $selection.each(function () {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function () {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    },
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function () {
  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function () {
      theme.Header.unload();
    },
  });

  return Header;
})();

theme.Maps = (function () {
  var config = {
    zoom: 14,
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError,
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]',
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center',
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function () {
    if (Shopify.designMode) {
      $(selectors.section).addClass(classes.mapError);
      $(selectors.map).remove();
      $(selectors.mapOverlay).after(
        '<div class="' +
        classes.errorMsg +
        '">' +
        theme.strings.authError +
        '</div>'
      );
    }
  };

  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (typeof this.key === 'undefined') {
      return;
    }

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function () {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function (index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function (results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function () {
      var $map = this.$map;

      return geolocate($map)
        .then(
          function (results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true,
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter(),
            });

            google.maps.event.addDomListener(
              window,
              'resize',
              $.debounce(250, function () {
                google.maps.event.trigger(map, 'resize');
                map.setCenter(center);
                $map.removeAttr('style');
              })
            );
          }.bind(this)
        )
        .fail(function () {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = errors.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = errors.addressQueryLimit;
              break;
            case 'REQUEST_DENIED':
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                classes.errorMsg +
                '">' +
                errorMessage +
                '</div>'
              );
          }
        });
    },

    onUnload: function () {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, 'resize');
    },
  });

  return Map;
})();

/* eslint-disable no-new */
theme.Product = (function () {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false,
    };

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      originalPrice: '#ProductPrice-' + sectionId,
      SKU: '.variant-sku',
      originalPriceWrapper: '.product-price__price-' + sectionId,
      originalSelectorId: '#ProductSelect-' + sectionId,
      productImageWraps: '.product-single__photo',
      productPrices: '.product-single__price-' + sectionId,
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      saleClasses: 'product-price__sale product-price__sale--single',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      save: '#Save',
      dynamicCheckout: '#dynamic-checkout-container',
    };

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    );

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      'js-zoom-enabled'
    );

    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._setActiveThumbnail();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function () {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function () {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function () {
          // initialize thumbnail slider on mobile if more than three thumbnails

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function (index) {
              _destroyZoom(this);
            });
          }

          self.settings.bpSmall = true;
        },
        unmatch: function () {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }

          self.settings.bpSmall = false;
        },
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function () {
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function (index) {
              _enableZoom(this);
            });
          }
        },
      });
    },

    _initVariants: function () {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject,
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAddToCart.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },

    _initImageSwitch: function () {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages).on('click', function (evt) {
        evt.preventDefault();
        var $el = $(this);

        var imageId = $el.data('thumbnail-id');

        self._switchImage(imageId);
        self._setActiveThumbnail(imageId);
      });
    },

    _setActiveThumbnail: function (imageId) {
      var activeClass = 'active-thumb';

      // If there is no element passed, find it by the current product image
      if (typeof imageId === 'undefined') {
        imageId = $(this.selectors.productImageWraps + ":not('.hide')").data(
          'image-id'
        );
      }

      var $thumbnail = $(
        this.selectors.productThumbImages +
        "[data-thumbnail-id='" +
        imageId +
        "']"
      );
      $(this.selectors.productThumbImages).removeClass(activeClass);
      $thumbnail.addClass(activeClass);
    },

    _switchImage: function (imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']"
      );
      var $otherImages = $(
        this.selectors.productImageWraps +
        ":not([data-image-id='" +
        imageId +
        "'])"
      );

      $newImage.removeClass('hide');
      $otherImages.addClass('hide');
    },

    _initThumbnailSlider: function () {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3,
            },
          },
        ],
      };

      $(this.selectors.productThumbs).slick(options);
      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function () {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;
    },

    _updateAddToCart: function (evt) {
      var variant = evt.variant;
      if (variant) {
        const ctaText = window.getProductCtaBtnText(variant);
        const dynamicCheckout = $(this.selectors.dynamicCheckout);
        $(this.selectors.productPrices)
          .removeClass('visibility-hidden')
          .attr('aria-hidden', 'true');
        if (variant.available) {
          $(this.selectors.addToCart).prop('disabled', false);
          $(this.selectors.addToCartText).text(ctaText);
          if (dynamicCheckout) {
            dynamicCheckout.removeClass('hidden');
          }
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).text(ctaText);
          if (dynamicCheckout) {
            dynamicCheckout.addClass('hidden');
          }
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).text(theme.strings.unavailable);
        $(this.selectors.productPrices)
          .addClass('visibility-hidden')
          .attr('aria-hidden', 'false');
      }
    },

    _updateImages: function (evt) {
      var variant = evt.variant;
      var imageId = variant.featured_image.id;

      this._switchImage(imageId);
      this._setActiveThumbnail(imageId);
    },

    _updatePrice: function (evt) {
      var variant = evt.variant;

      // Update the product price
      $(this.selectors.originalPrice).html(
        theme.Currency.formatMoney(variant.price, theme.moneyFormat)
      );

      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice)
          .html(
            theme.Currency.formatMoney(
              variant.compare_at_price,
              theme.moneyFormat
            )
          )
          .removeClass('hide');

        $(this.selectors.originalPriceWrapper).addClass(
          this.selectors.saleClasses
        );

        $(this.selectors.saleLabel).removeClass('hide');
        $(this.selectors.save)
          .html(
            Math.round(
              ((variant.compare_at_price - variant.price) * 100) /
              variant.compare_at_price
            ) + '%'
          )
          .removeClass('hide');
      } else {
        $(this.selectors.comparePrice).addClass('hide');
        $(this.selectors.saleLabel).addClass('hide');
        $(this.selectors.originalPriceWrapper).removeClass(
          this.selectors.saleClasses
        );
        $(this.selectors.save).addClass('hide');
      }
    },

    _updateSKU: function (evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function () {
      this.$container.off(this.settings.namespace);
    },
  });

  function _enableZoom(el) {
    var zoomUrl = $(el).data('zoom');
    $(el).zoom({
      url: zoomUrl,
    });
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy');
  }

  return Product;
})();

theme.Quotes = (function () {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0,
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: true,
    touchThreshold: 20,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  function Quotes(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var wrapper = (this.wrapper = '.quotes-wrapper');
    var slider = (this.slider = '#Quotes-' + sectionId);
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function () {
        initSlider($slider, mobileOptions);
      },
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function () {
        initSlider($slider, defaults);
      },
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function () {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function (evt) {
      // Ignore the cloned version
      var $slide = $(
        '.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function (event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },
  });

  return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function () {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

    $('.slideshow__video', slideshow).each(function () {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function () {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function (evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function () {
      // Resume autoplay
      $(this.slideshow).slick('slickPlay');
    },
  }
);

$(document).ready(function () {
  var sections = new theme.Sections();

  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('quotes', theme.Quotes);
});

theme.init = function () {
  theme.customerTemplates.init();

  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function (evt) {
    evt.preventDefault();
  });
};

$(theme.init);
jQuery('#notify-me').click(function () {
  jQuery('#notify-me-wrapper').fadeIn();

  return false;
});

// inview js
(function ($) {
  $.belowthefold = function (element, settings) {
    var fold = $(window).height() + $(window).scrollTop();
    return fold <= $(element).offset().top - settings.threshold;
  };
  $.abovethetop = function (element, settings) {
    var top = $(window).scrollTop();
    return (
      top >= $(element).offset().top + $(element).height() - settings.threshold
    );
  };
  $.rightofscreen = function (element, settings) {
    var fold = $(window).width() + $(window).scrollLeft();
    return fold <= $(element).offset().left - settings.threshold;
  };
  $.leftofscreen = function (element, settings) {
    var left = $(window).scrollLeft();
    return (
      left >= $(element).offset().left + $(element).width() - settings.threshold
    );
  };
  $.inviewport = function (element, settings) {
    return (
      !$.rightofscreen(element, settings) &&
      !$.leftofscreen(element, settings) &&
      !$.belowthefold(element, settings) &&
      !$.abovethetop(element, settings)
    );
  };
  $.extend($.expr[':'], {
    'below-the-fold': function (a, i, m) {
      return $.belowthefold(a, { threshold: 0 });
    },
    'above-the-top': function (a, i, m) {
      return $.abovethetop(a, { threshold: 0 });
    },
    'left-of-screen': function (a, i, m) {
      return $.leftofscreen(a, { threshold: 0 });
    },
    'right-of-screen': function (a, i, m) {
      return $.rightofscreen(a, { threshold: 0 });
    },
    'in-viewport': function (a, i, m) {
      return $.inviewport(a, { threshold: 0 });
    },
  });
})(jQuery);

//bx-slider
!(function (t) {
  var e = {
    mode: 'horizontal',
    slideSelector: '',
    infiniteLoop: !0,
    hideControlOnEnd: !1,
    speed: 500,
    easing: null,
    slideMargin: 0,
    startSlide: 0,
    randomStart: !1,
    captions: !1,
    ticker: !1,
    tickerHover: !1,
    adaptiveHeight: !1,
    adaptiveHeightSpeed: 500,
    video: !1,
    useCSS: !0,
    preloadImages: 'visible',
    responsive: !0,
    slideZIndex: 50,
    wrapperClass: 'bx-wrapper',
    touchEnabled: !0,
    swipeThreshold: 50,
    oneToOneTouch: !0,
    preventDefaultSwipeX: !0,
    preventDefaultSwipeY: !1,
    ariaLive: !0,
    ariaHidden: !0,
    keyboardEnabled: !1,
    pager: !0,
    pagerType: 'full',
    pagerShortSeparator: ' / ',
    pagerSelector: null,
    buildPager: null,
    pagerCustom: null,
    controls: !0,
    nextText: 'Next',
    prevText: 'Prev',
    nextSelector: null,
    prevSelector: null,
    autoControls: !1,
    startText: 'Start',
    stopText: 'Stop',
    autoControlsCombine: !1,
    autoControlsSelector: null,
    auto: !1,
    pause: 4e3,
    autoStart: !0,
    autoDirection: 'next',
    stopAutoOnClick: !1,
    autoHover: !1,
    autoDelay: 0,
    autoSlideForOnePage: !1,
    minSlides: 1,
    maxSlides: 1,
    moveSlides: 0,
    slideWidth: 0,
    shrinkItems: !1,
    onSliderLoad: function () {
      return !0;
    },
    onSlideBefore: function () {
      return !0;
    },
    onSlideAfter: function () {
      return !0;
    },
    onSlideNext: function () {
      return !0;
    },
    onSlidePrev: function () {
      return !0;
    },
    onSliderResize: function () {
      return !0;
    },
  };
  t.fn.bxSlider = function (n) {
    if (0 === this.length) return this;
    if (this.length > 1)
      return (
        this.each(function () {
          t(this).bxSlider(n);
        }),
        this
      );
    var s = {},
      o = this,
      r = t(window).width(),
      a = t(window).height();
    if (!t(o).data('bxSlider')) {
      var l = function () {
        t(o).data('bxSlider') ||
          ((s.settings = t.extend({}, e, n)),
            (s.settings.slideWidth = parseInt(s.settings.slideWidth)),
            (s.children = o.children(s.settings.slideSelector)),
            s.children.length < s.settings.minSlides &&
            (s.settings.minSlides = s.children.length),
            s.children.length < s.settings.maxSlides &&
            (s.settings.maxSlides = s.children.length),
            s.settings.randomStart &&
            (s.settings.startSlide = Math.floor(
              Math.random() * s.children.length
            )),
            (s.active = { index: s.settings.startSlide }),
            (s.carousel = s.settings.minSlides > 1 || s.settings.maxSlides > 1),
            s.carousel && (s.settings.preloadImages = 'all'),
            (s.minThreshold =
              s.settings.minSlides * s.settings.slideWidth +
              (s.settings.minSlides - 1) * s.settings.slideMargin),
            (s.maxThreshold =
              s.settings.maxSlides * s.settings.slideWidth +
              (s.settings.maxSlides - 1) * s.settings.slideMargin),
            (s.working = !1),
            (s.controls = {}),
            (s.interval = null),
            (s.animProp = 'vertical' === s.settings.mode ? 'top' : 'left'),
            (s.usingCSS =
              s.settings.useCSS &&
              'fade' !== s.settings.mode &&
              (function () {
                for (
                  var t = document.createElement('div'),
                  e = [
                    'WebkitPerspective',
                    'MozPerspective',
                    'OPerspective',
                    'msPerspective',
                  ],
                  i = 0;
                  i < e.length;
                  i++
                )
                  if (void 0 !== t.style[e[i]])
                    return (
                      (s.cssPrefix = e[i]
                        .replace('Perspective', '')
                        .toLowerCase()),
                      (s.animProp = '-' + s.cssPrefix + '-transform'),
                      !0
                    );
                return !1;
              })()),
            'vertical' === s.settings.mode &&
            (s.settings.maxSlides = s.settings.minSlides),
            o.data('origStyle', o.attr('style')),
            o.children(s.settings.slideSelector).each(function () {
              t(this).data('origStyle', t(this).attr('style'));
            }),
            d());
      },
        d = function () {
          var e = s.children.eq(s.settings.startSlide);
          o.wrap(
            '<div class="' +
            s.settings.wrapperClass +
            '"><div class="bx-viewport"></div></div>'
          ),
            (s.viewport = o.parent()),
            s.settings.ariaLive &&
            !s.settings.ticker &&
            s.viewport.attr('aria-live', 'polite'),
            (s.loader = t('<div class="bx-loading" />')),
            s.viewport.prepend(s.loader),
            o.css({
              width:
                'horizontal' === s.settings.mode
                  ? 1e3 * s.children.length + 215 + '%'
                  : 'auto',
              position: 'relative',
            }),
            s.usingCSS && s.settings.easing
              ? o.css(
                '-' + s.cssPrefix + '-transition-timing-function',
                s.settings.easing
              )
              : s.settings.easing || (s.settings.easing = 'swing'),
            s.viewport.css({
              width: '100%',
              overflow: 'hidden',
              position: 'relative',
            }),
            s.viewport.parent().css({ maxWidth: u() }),
            s.children.css({
              float: 'horizontal' === s.settings.mode ? 'left' : 'none',
              listStyle: 'none',
              position: 'relative',
            }),
            s.children.css('width', h()),
            'horizontal' === s.settings.mode &&
            s.settings.slideMargin > 0 &&
            s.children.css('marginRight', s.settings.slideMargin),
            'vertical' === s.settings.mode &&
            s.settings.slideMargin > 0 &&
            s.children.css('marginBottom', s.settings.slideMargin),
            'fade' === s.settings.mode &&
            (s.children.css({
              position: 'absolute',
              zIndex: 0,
              display: 'none',
            }),
              s.children
                .eq(s.settings.startSlide)
                .css({ zIndex: s.settings.slideZIndex, display: 'block' })),
            (s.controls.el = t('<div class="bx-controls" />')),
            s.settings.captions && P(),
            (s.active.last = s.settings.startSlide === f() - 1),
            s.settings.video && o.fitVids(),
            ('all' === s.settings.preloadImages || s.settings.ticker) &&
            (e = s.children),
            s.settings.ticker
              ? (s.settings.pager = !1)
              : (s.settings.controls && C(),
                s.settings.auto && s.settings.autoControls && T(),
                s.settings.pager && w(),
                (s.settings.controls ||
                  s.settings.autoControls ||
                  s.settings.pager) &&
                s.viewport.after(s.controls.el)),
            c(e, g);
        },
        c = function (e, i) {
          var n = e.find('img:not([src=""]), iframe').length,
            s = 0;
          return 0 === n
            ? void i()
            : void e.find('img:not([src=""]), iframe').each(function () {
              t(this)
                .one('load error', function () {
                  ++s === n && i();
                })
                .each(function () {
                  this.complete && t(this).trigger('load');
                });
            });
        },
        g = function () {
          if (
            s.settings.infiniteLoop &&
            'fade' !== s.settings.mode &&
            !s.settings.ticker
          ) {
            var e =
              'vertical' === s.settings.mode
                ? s.settings.minSlides
                : s.settings.maxSlides,
              i = s.children.slice(0, e).clone(!0).addClass('bx-clone'),
              n = s.children.slice(-e).clone(!0).addClass('bx-clone');
            s.settings.ariaHidden &&
              (i.attr('aria-hidden', !0), n.attr('aria-hidden', !0)),
              o.append(i).prepend(n);
          }
          s.loader.remove(),
            m(),
            'vertical' === s.settings.mode && (s.settings.adaptiveHeight = !0),
            s.viewport.height(p()),
            o.redrawSlider(),
            s.settings.onSliderLoad.call(o, s.active.index),
            (s.initialized = !0),
            s.settings.responsive && t(window).bind('resize', Z),
            s.settings.auto &&
            s.settings.autoStart &&
            (f() > 1 || s.settings.autoSlideForOnePage) &&
            H(),
            s.settings.ticker && W(),
            s.settings.pager && I(s.settings.startSlide),
            s.settings.controls && D(),
            s.settings.touchEnabled && !s.settings.ticker && N(),
            s.settings.keyboardEnabled &&
            !s.settings.ticker &&
            t(document).keydown(F);
        },
        p = function () {
          var e = 0,
            n = t();
          if ('vertical' === s.settings.mode || s.settings.adaptiveHeight)
            if (s.carousel) {
              var o =
                1 === s.settings.moveSlides
                  ? s.active.index
                  : s.active.index * x();
              for (
                n = s.children.eq(o), i = 1;
                i <= s.settings.maxSlides - 1;
                i++
              )
                n =
                  o + i >= s.children.length
                    ? n.add(s.children.eq(i - 1))
                    : n.add(s.children.eq(o + i));
            } else n = s.children.eq(s.active.index);
          else n = s.children;
          return (
            'vertical' === s.settings.mode
              ? (n.each(function (i) {
                e += t(this).outerHeight();
              }),
                s.settings.slideMargin > 0 &&
                (e += s.settings.slideMargin * (s.settings.minSlides - 1)))
              : (e = Math.max.apply(
                Math,
                n
                  .map(function () {
                    return t(this).outerHeight(!1);
                  })
                  .get()
              )),
            'border-box' === s.viewport.css('box-sizing')
              ? (e +=
                parseFloat(s.viewport.css('padding-top')) +
                parseFloat(s.viewport.css('padding-bottom')) +
                parseFloat(s.viewport.css('border-top-width')) +
                parseFloat(s.viewport.css('border-bottom-width')))
              : 'padding-box' === s.viewport.css('box-sizing') &&
              (e +=
                parseFloat(s.viewport.css('padding-top')) +
                parseFloat(s.viewport.css('padding-bottom'))),
            e
          );
        },
        u = function () {
          var t = '100%';
          return (
            s.settings.slideWidth > 0 &&
            (t =
              'horizontal' === s.settings.mode
                ? s.settings.maxSlides * s.settings.slideWidth +
                (s.settings.maxSlides - 1) * s.settings.slideMargin
                : s.settings.slideWidth),
            t
          );
        },
        h = function () {
          var t = s.settings.slideWidth,
            e = s.viewport.width();
          if (
            0 === s.settings.slideWidth ||
            (s.settings.slideWidth > e && !s.carousel) ||
            'vertical' === s.settings.mode
          )
            t = e;
          else if (
            s.settings.maxSlides > 1 &&
            'horizontal' === s.settings.mode
          ) {
            if (e > s.maxThreshold) return t;
            e < s.minThreshold
              ? (t =
                (e - s.settings.slideMargin * (s.settings.minSlides - 1)) /
                s.settings.minSlides)
              : s.settings.shrinkItems &&
              (t = Math.floor(
                (e + s.settings.slideMargin) /
                Math.ceil(
                  (e + s.settings.slideMargin) /
                  (t + s.settings.slideMargin)
                ) -
                s.settings.slideMargin
              ));
          }
          return t;
        },
        v = function () {
          var t = 1,
            e = null;
          return (
            'horizontal' === s.settings.mode && s.settings.slideWidth > 0
              ? s.viewport.width() < s.minThreshold
                ? (t = s.settings.minSlides)
                : s.viewport.width() > s.maxThreshold
                  ? (t = s.settings.maxSlides)
                  : ((e = s.children.first().width() + s.settings.slideMargin),
                    (t = Math.floor(
                      (s.viewport.width() + s.settings.slideMargin) / e
                    )))
              : 'vertical' === s.settings.mode && (t = s.settings.minSlides),
            t
          );
        },
        f = function () {
          var t = 0,
            e = 0,
            i = 0;
          if (s.settings.moveSlides > 0)
            if (s.settings.infiniteLoop) t = Math.ceil(s.children.length / x());
            else
              for (; e < s.children.length;)
                ++t,
                  (e = i + v()),
                  (i +=
                    s.settings.moveSlides <= v() ? s.settings.moveSlides : v());
          else t = Math.ceil(s.children.length / v());
          return t;
        },
        x = function () {
          return s.settings.moveSlides > 0 && s.settings.moveSlides <= v()
            ? s.settings.moveSlides
            : v();
        },
        m = function () {
          var t, e, i;
          s.children.length > s.settings.maxSlides &&
            s.active.last &&
            !s.settings.infiniteLoop
            ? 'horizontal' === s.settings.mode
              ? ((e = s.children.last()),
                (t = e.position()),
                S(
                  -(t.left - (s.viewport.width() - e.outerWidth())),
                  'reset',
                  0
                ))
              : 'vertical' === s.settings.mode &&
              ((i = s.children.length - s.settings.minSlides),
                (t = s.children.eq(i).position()),
                S(-t.top, 'reset', 0))
            : ((t = s.children.eq(s.active.index * x()).position()),
              s.active.index === f() - 1 && (s.active.last = !0),
              void 0 !== t &&
              ('horizontal' === s.settings.mode
                ? S(-t.left, 'reset', 0)
                : 'vertical' === s.settings.mode && S(-t.top, 'reset', 0)));
        },
        S = function (e, i, n, r) {
          var a, l;
          s.usingCSS
            ? ((l =
              'vertical' === s.settings.mode
                ? 'translate3d(0, ' + e + 'px, 0)'
                : 'translate3d(' + e + 'px, 0, 0)'),
              o.css('-' + s.cssPrefix + '-transition-duration', n / 1e3 + 's'),
              'slide' === i
                ? (o.css(s.animProp, l),
                  0 !== n
                    ? o.bind(
                      'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd',
                      function (e) {
                        t(e.target).is(o) &&
                          (o.unbind(
                            'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd'
                          ),
                            q());
                      }
                    )
                    : q())
                : 'reset' === i
                  ? o.css(s.animProp, l)
                  : 'ticker' === i &&
                  (o.css(
                    '-' + s.cssPrefix + '-transition-timing-function',
                    'linear'
                  ),
                    o.css(s.animProp, l),
                    0 !== n
                      ? o.bind(
                        'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd',
                        function (e) {
                          t(e.target).is(o) &&
                            (o.unbind(
                              'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd'
                            ),
                              S(r.resetValue, 'reset', 0),
                              L());
                        }
                      )
                      : (S(r.resetValue, 'reset', 0), L())))
            : ((a = {}),
              (a[s.animProp] = e),
              'slide' === i
                ? o.animate(a, n, s.settings.easing, function () {
                  q();
                })
                : 'reset' === i
                  ? o.css(s.animProp, e)
                  : 'ticker' === i &&
                  o.animate(a, n, 'linear', function () {
                    S(r.resetValue, 'reset', 0), L();
                  }));
        },
        b = function () {
          for (var e = '', i = '', n = f(), o = 0; o < n; o++)
            (i = ''),
              (s.settings.buildPager && t.isFunction(s.settings.buildPager)) ||
                s.settings.pagerCustom
                ? ((i = s.settings.buildPager(o)),
                  s.pagerEl.addClass('bx-custom-pager'))
                : ((i = o + 1), s.pagerEl.addClass('bx-default-pager')),
              (e +=
                '<div class="bx-pager-item"><a href="" data-slide-index="' +
                o +
                '" class="bx-pager-link">' +
                i +
                '</a></div>');
          s.pagerEl.html(e);
        },
        w = function () {
          s.settings.pagerCustom
            ? (s.pagerEl = t(s.settings.pagerCustom))
            : ((s.pagerEl = t('<div class="bx-pager" />')),
              s.settings.pagerSelector
                ? t(s.settings.pagerSelector).html(s.pagerEl)
                : s.controls.el.addClass('bx-has-pager').append(s.pagerEl),
              b()),
            s.pagerEl.on('click touchend', 'a', z);
        },
        C = function () {
          (s.controls.next = t(
            '<a class="bx-next" href="">' + s.settings.nextText + '</a>'
          )),
            (s.controls.prev = t(
              '<a class="bx-prev" href="">' + s.settings.prevText + '</a>'
            )),
            s.controls.next.bind('click touchend', E),
            s.controls.prev.bind('click touchend', k),
            s.settings.nextSelector &&
            t(s.settings.nextSelector).append(s.controls.next),
            s.settings.prevSelector &&
            t(s.settings.prevSelector).append(s.controls.prev),
            s.settings.nextSelector ||
            s.settings.prevSelector ||
            ((s.controls.directionEl = t(
              '<div class="bx-controls-direction" />'
            )),
              s.controls.directionEl
                .append(s.controls.prev)
                .append(s.controls.next),
              s.controls.el
                .addClass('bx-has-controls-direction')
                .append(s.controls.directionEl));
        },
        T = function () {
          (s.controls.start = t(
            '<div class="bx-controls-auto-item"><a class="bx-start" href="">' +
            s.settings.startText +
            '</a></div>'
          )),
            (s.controls.stop = t(
              '<div class="bx-controls-auto-item"><a class="bx-stop" href="">' +
              s.settings.stopText +
              '</a></div>'
            )),
            (s.controls.autoEl = t('<div class="bx-controls-auto" />')),
            s.controls.autoEl.on('click', '.bx-start', M),
            s.controls.autoEl.on('click', '.bx-stop', y),
            s.settings.autoControlsCombine
              ? s.controls.autoEl.append(s.controls.start)
              : s.controls.autoEl
                .append(s.controls.start)
                .append(s.controls.stop),
            s.settings.autoControlsSelector
              ? t(s.settings.autoControlsSelector).html(s.controls.autoEl)
              : s.controls.el
                .addClass('bx-has-controls-auto')
                .append(s.controls.autoEl),
            A(s.settings.autoStart ? 'stop' : 'start');
        },
        P = function () {
          s.children.each(function (e) {
            var i = t(this).find('img:first').attr('title');
            void 0 !== i &&
              ('' + i).length &&
              t(this).append(
                '<div class="bx-caption"><span>' + i + '</span></div>'
              );
          });
        },
        E = function (t) {
          t.preventDefault(),
            s.controls.el.hasClass('disabled') ||
            (s.settings.auto && s.settings.stopAutoOnClick && o.stopAuto(),
              o.goToNextSlide());
        },
        k = function (t) {
          t.preventDefault(),
            s.controls.el.hasClass('disabled') ||
            (s.settings.auto && s.settings.stopAutoOnClick && o.stopAuto(),
              o.goToPrevSlide());
        },
        M = function (t) {
          o.startAuto(), t.preventDefault();
        },
        y = function (t) {
          o.stopAuto(), t.preventDefault();
        },
        z = function (e) {
          var i, n;
          e.preventDefault(),
            s.controls.el.hasClass('disabled') ||
            (s.settings.auto && s.settings.stopAutoOnClick && o.stopAuto(),
              (i = t(e.currentTarget)),
              void 0 !== i.attr('data-slide-index') &&
              ((n = parseInt(i.attr('data-slide-index'))),
                n !== s.active.index && o.goToSlide(n)));
        },
        I = function (e) {
          var i = s.children.length;
          return 'short' === s.settings.pagerType
            ? (s.settings.maxSlides > 1 &&
              (i = Math.ceil(s.children.length / s.settings.maxSlides)),
              void s.pagerEl.html(e + 1 + s.settings.pagerShortSeparator + i))
            : (s.pagerEl.find('a').removeClass('active'),
              void s.pagerEl.each(function (i, n) {
                t(n).find('a').eq(e).addClass('active');
              }));
        },
        q = function () {
          if (s.settings.infiniteLoop) {
            var t = '';
            0 === s.active.index
              ? (t = s.children.eq(0).position())
              : s.active.index === f() - 1 && s.carousel
                ? (t = s.children.eq((f() - 1) * x()).position())
                : s.active.index === s.children.length - 1 &&
                (t = s.children.eq(s.children.length - 1).position()),
              t &&
              ('horizontal' === s.settings.mode
                ? S(-t.left, 'reset', 0)
                : 'vertical' === s.settings.mode && S(-t.top, 'reset', 0));
          }
          (s.working = !1),
            s.settings.onSlideAfter.call(
              o,
              s.children.eq(s.active.index),
              s.oldIndex,
              s.active.index
            );
        },
        A = function (t) {
          s.settings.autoControlsCombine
            ? s.controls.autoEl.html(s.controls[t])
            : (s.controls.autoEl.find('a').removeClass('active'),
              s.controls.autoEl
                .find('a:not(.bx-' + t + ')')
                .addClass('active'));
        },
        D = function () {
          1 === f()
            ? (s.controls.prev.addClass('disabled'),
              s.controls.next.addClass('disabled'))
            : !s.settings.infiniteLoop &&
            s.settings.hideControlOnEnd &&
            (0 === s.active.index
              ? (s.controls.prev.addClass('disabled'),
                s.controls.next.removeClass('disabled'))
              : s.active.index === f() - 1
                ? (s.controls.next.addClass('disabled'),
                  s.controls.prev.removeClass('disabled'))
                : (s.controls.prev.removeClass('disabled'),
                  s.controls.next.removeClass('disabled')));
        },
        H = function () {
          if (s.settings.autoDelay > 0) {
            setTimeout(o.startAuto, s.settings.autoDelay);
          } else
            o.startAuto(),
              t(window)
                .focus(function () {
                  o.startAuto();
                })
                .blur(function () {
                  o.stopAuto();
                });
          s.settings.autoHover &&
            o.hover(
              function () {
                s.interval && (o.stopAuto(!0), (s.autoPaused = !0));
              },
              function () {
                s.autoPaused && (o.startAuto(!0), (s.autoPaused = null));
              }
            );
        },
        W = function () {
          var e,
            i,
            n,
            r,
            a,
            l,
            d,
            c,
            g = 0;
          'next' === s.settings.autoDirection
            ? o.append(s.children.clone().addClass('bx-clone'))
            : (o.prepend(s.children.clone().addClass('bx-clone')),
              (e = s.children.first().position()),
              (g = 'horizontal' === s.settings.mode ? -e.left : -e.top)),
            S(g, 'reset', 0),
            (s.settings.pager = !1),
            (s.settings.controls = !1),
            (s.settings.autoControls = !1),
            s.settings.tickerHover &&
            (s.usingCSS
              ? ((r = 'horizontal' === s.settings.mode ? 4 : 5),
                s.viewport.hover(
                  function () {
                    (i = o.css('-' + s.cssPrefix + '-transform')),
                      (n = parseFloat(i.split(',')[r])),
                      S(n, 'reset', 0);
                  },
                  function () {
                    (c = 0),
                      s.children.each(function (e) {
                        c +=
                          'horizontal' === s.settings.mode
                            ? t(this).outerWidth(!0)
                            : t(this).outerHeight(!0);
                      }),
                      (a = s.settings.speed / c),
                      (l = 'horizontal' === s.settings.mode ? 'left' : 'top'),
                      (d = a * (c - Math.abs(parseInt(n)))),
                      L(d);
                  }
                ))
              : s.viewport.hover(
                function () {
                  o.stop();
                },
                function () {
                  (c = 0),
                    s.children.each(function (e) {
                      c +=
                        'horizontal' === s.settings.mode
                          ? t(this).outerWidth(!0)
                          : t(this).outerHeight(!0);
                    }),
                    (a = s.settings.speed / c),
                    (l = 'horizontal' === s.settings.mode ? 'left' : 'top'),
                    (d = a * (c - Math.abs(parseInt(o.css(l))))),
                    L(d);
                }
              )),
            L();
        },
        L = function (t) {
          var e,
            i,
            n,
            r = t ? t : s.settings.speed,
            a = { left: 0, top: 0 },
            l = { left: 0, top: 0 };
          'next' === s.settings.autoDirection
            ? (a = o.find('.bx-clone').first().position())
            : (l = s.children.first().position()),
            (e = 'horizontal' === s.settings.mode ? -a.left : -a.top),
            (i = 'horizontal' === s.settings.mode ? -l.left : -l.top),
            (n = { resetValue: i }),
            S(e, 'ticker', r, n);
        },
        O = function (e) {
          var i = t(window),
            n = { top: i.scrollTop(), left: i.scrollLeft() },
            s = e.offset();
          return (
            (n.right = n.left + i.width()),
            (n.bottom = n.top + i.height()),
            (s.right = s.left + e.outerWidth()),
            (s.bottom = s.top + e.outerHeight()),
            !(
              n.right < s.left ||
              n.left > s.right ||
              n.bottom < s.top ||
              n.top > s.bottom
            )
          );
        },
        F = function (t) {
          var e = document.activeElement.tagName.toLowerCase(),
            i = 'input|textarea',
            n = new RegExp(e, ['i']),
            s = n.exec(i);
          if (null == s && O(o)) {
            if (39 === t.keyCode) return E(t), !1;
            if (37 === t.keyCode) return k(t), !1;
          }
        },
        N = function () {
          (s.touch = { start: { x: 0, y: 0 }, end: { x: 0, y: 0 } }),
            s.viewport.bind('touchstart MSPointerDown pointerdown', X),
            s.viewport.on('click', '.bxslider a', function (t) {
              s.viewport.hasClass('click-disabled') &&
                (t.preventDefault(), s.viewport.removeClass('click-disabled'));
            });
        },
        X = function (t) {
          if ((s.controls.el.addClass('disabled'), s.working))
            t.preventDefault(), s.controls.el.removeClass('disabled');
          else {
            s.touch.originalPos = o.position();
            var e = t.originalEvent,
              i =
                'undefined' != typeof e.changedTouches ? e.changedTouches : [e];
            (s.touch.start.x = i[0].pageX),
              (s.touch.start.y = i[0].pageY),
              s.viewport.get(0).setPointerCapture &&
              ((s.pointerId = e.pointerId),
                s.viewport.get(0).setPointerCapture(s.pointerId)),
              s.viewport.bind('touchmove MSPointerMove pointermove', V),
              s.viewport.bind('touchend MSPointerUp pointerup', R),
              s.viewport.bind('MSPointerCancel pointercancel', Y);
          }
        },
        Y = function (t) {
          S(s.touch.originalPos.left, 'reset', 0),
            s.controls.el.removeClass('disabled'),
            s.viewport.unbind('MSPointerCancel pointercancel', Y),
            s.viewport.unbind('touchmove MSPointerMove pointermove', V),
            s.viewport.unbind('touchend MSPointerUp pointerup', R),
            s.viewport.get(0).releasePointerCapture &&
            s.viewport.get(0).releasePointerCapture(s.pointerId);
        },
        V = function (t) {
          var e = t.originalEvent,
            i = 'undefined' != typeof e.changedTouches ? e.changedTouches : [e],
            n = Math.abs(i[0].pageX - s.touch.start.x),
            o = Math.abs(i[0].pageY - s.touch.start.y),
            r = 0,
            a = 0;
          3 * n > o && s.settings.preventDefaultSwipeX
            ? t.preventDefault()
            : 3 * o > n &&
            s.settings.preventDefaultSwipeY &&
            t.preventDefault(),
            'fade' !== s.settings.mode &&
            s.settings.oneToOneTouch &&
            ('horizontal' === s.settings.mode
              ? ((a = i[0].pageX - s.touch.start.x),
                (r = s.touch.originalPos.left + a))
              : ((a = i[0].pageY - s.touch.start.y),
                (r = s.touch.originalPos.top + a)),
              S(r, 'reset', 0));
        },
        R = function (t) {
          s.viewport.unbind('touchmove MSPointerMove pointermove', V),
            s.controls.el.removeClass('disabled');
          var e = t.originalEvent,
            i = 'undefined' != typeof e.changedTouches ? e.changedTouches : [e],
            n = 0,
            r = 0;
          (s.touch.end.x = i[0].pageX),
            (s.touch.end.y = i[0].pageY),
            'fade' === s.settings.mode
              ? ((r = Math.abs(s.touch.start.x - s.touch.end.x)),
                r >= s.settings.swipeThreshold &&
                (s.touch.start.x > s.touch.end.x
                  ? o.goToNextSlide()
                  : o.goToPrevSlide(),
                  o.stopAuto()))
              : ('horizontal' === s.settings.mode
                ? ((r = s.touch.end.x - s.touch.start.x),
                  (n = s.touch.originalPos.left))
                : ((r = s.touch.end.y - s.touch.start.y),
                  (n = s.touch.originalPos.top)),
                !s.settings.infiniteLoop &&
                  ((0 === s.active.index && r > 0) || (s.active.last && r < 0))
                  ? S(n, 'reset', 200)
                  : Math.abs(r) >= s.settings.swipeThreshold
                    ? (r < 0 ? o.goToNextSlide() : o.goToPrevSlide(),
                      o.stopAuto())
                    : S(n, 'reset', 200)),
            s.viewport.unbind('touchend MSPointerUp pointerup', R),
            s.viewport.get(0).releasePointerCapture &&
            s.viewport.get(0).releasePointerCapture(s.pointerId);
        },
        Z = function (e) {
          if (s.initialized)
            if (s.working) window.setTimeout(Z, 10);
            else {
              var i = t(window).width(),
                n = t(window).height();
              (r === i && a === n) ||
                ((r = i),
                  (a = n),
                  o.redrawSlider(),
                  s.settings.onSliderResize.call(o, s.active.index));
            }
        },
        B = function (t) {
          var e = v();
          s.settings.ariaHidden &&
            !s.settings.ticker &&
            (s.children.attr('aria-hidden', 'true'),
              s.children.slice(t, t + e).attr('aria-hidden', 'false'));
        },
        U = function (t) {
          return t < 0
            ? s.settings.infiniteLoop
              ? f() - 1
              : s.active.index
            : t >= f()
              ? s.settings.infiniteLoop
                ? 0
                : s.active.index
              : t;
        };
      return (
        (o.goToSlide = function (e, i) {
          var n,
            r,
            a,
            l,
            d = !0,
            c = 0,
            g = { left: 0, top: 0 },
            u = null;
          if (
            ((s.oldIndex = s.active.index),
              (s.active.index = U(e)),
              !s.working && s.active.index !== s.oldIndex)
          ) {
            if (
              ((s.working = !0),
                (d = s.settings.onSlideBefore.call(
                  o,
                  s.children.eq(s.active.index),
                  s.oldIndex,
                  s.active.index
                )),
                'undefined' != typeof d && !d)
            )
              return (s.active.index = s.oldIndex), void (s.working = !1);
            'next' === i
              ? s.settings.onSlideNext.call(
                o,
                s.children.eq(s.active.index),
                s.oldIndex,
                s.active.index
              ) || (d = !1)
              : 'prev' === i &&
              (s.settings.onSlidePrev.call(
                o,
                s.children.eq(s.active.index),
                s.oldIndex,
                s.active.index
              ) ||
                (d = !1)),
              (s.active.last = s.active.index >= f() - 1),
              (s.settings.pager || s.settings.pagerCustom) && I(s.active.index),
              s.settings.controls && D(),
              'fade' === s.settings.mode
                ? (s.settings.adaptiveHeight &&
                  s.viewport.height() !== p() &&
                  s.viewport.animate(
                    { height: p() },
                    s.settings.adaptiveHeightSpeed
                  ),
                  s.children
                    .filter(':visible')
                    .fadeOut(s.settings.speed)
                    .css({ zIndex: 0 }),
                  s.children
                    .eq(s.active.index)
                    .css('zIndex', s.settings.slideZIndex + 1)
                    .fadeIn(s.settings.speed, function () {
                      t(this).css('zIndex', s.settings.slideZIndex), q();
                    }))
                : (s.settings.adaptiveHeight &&
                  s.viewport.height() !== p() &&
                  s.viewport.animate(
                    { height: p() },
                    s.settings.adaptiveHeightSpeed
                  ),
                  !s.settings.infiniteLoop && s.carousel && s.active.last
                    ? 'horizontal' === s.settings.mode
                      ? ((u = s.children.eq(s.children.length - 1)),
                        (g = u.position()),
                        (c = s.viewport.width() - u.outerWidth()))
                      : ((n = s.children.length - s.settings.minSlides),
                        (g = s.children.eq(n).position()))
                    : s.carousel && s.active.last && 'prev' === i
                      ? ((r =
                        1 === s.settings.moveSlides
                          ? s.settings.maxSlides - x()
                          : (f() - 1) * x() -
                          (s.children.length - s.settings.maxSlides)),
                        (u = o.children('.bx-clone').eq(r)),
                        (g = u.position()))
                      : 'next' === i && 0 === s.active.index
                        ? ((g = o
                          .find('> .bx-clone')
                          .eq(s.settings.maxSlides)
                          .position()),
                          (s.active.last = !1))
                        : e >= 0 &&
                        ((l = e * parseInt(x())),
                          (g = s.children.eq(l).position())),
                  'undefined' != typeof g
                    ? ((a =
                      'horizontal' === s.settings.mode
                        ? -(g.left - c)
                        : -g.top),
                      S(a, 'slide', s.settings.speed))
                    : (s.working = !1)),
              s.settings.ariaHidden && B(s.active.index * x());
          }
        }),
        (o.goToNextSlide = function () {
          if (s.settings.infiniteLoop || !s.active.last) {
            var t = parseInt(s.active.index) + 1;
            o.goToSlide(t, 'next');
          }
        }),
        (o.goToPrevSlide = function () {
          if (s.settings.infiniteLoop || 0 !== s.active.index) {
            var t = parseInt(s.active.index) - 1;
            o.goToSlide(t, 'prev');
          }
        }),
        (o.startAuto = function (t) {
          s.interval ||
            ((s.interval = setInterval(function () {
              'next' === s.settings.autoDirection
                ? o.goToNextSlide()
                : o.goToPrevSlide();
            }, s.settings.pause)),
              s.settings.autoControls && t !== !0 && A('stop'));
        }),
        (o.stopAuto = function (t) {
          s.interval &&
            (clearInterval(s.interval),
              (s.interval = null),
              s.settings.autoControls && t !== !0 && A('start'));
        }),
        (o.getCurrentSlide = function () {
          return s.active.index;
        }),
        (o.getCurrentSlideElement = function () {
          return s.children.eq(s.active.index);
        }),
        (o.getSlideElement = function (t) {
          return s.children.eq(t);
        }),
        (o.getSlideCount = function () {
          return s.children.length;
        }),
        (o.isWorking = function () {
          return s.working;
        }),
        (o.redrawSlider = function () {
          s.children.add(o.find('.bx-clone')).outerWidth(h()),
            s.viewport.css('height', p()),
            s.settings.ticker || m(),
            s.active.last && (s.active.index = f() - 1),
            s.active.index >= f() && (s.active.last = !0),
            s.settings.pager &&
            !s.settings.pagerCustom &&
            (b(), I(s.active.index)),
            s.settings.ariaHidden && B(s.active.index * x());
        }),
        (o.destroySlider = function () {
          s.initialized &&
            ((s.initialized = !1),
              t('.bx-clone', this).remove(),
              s.children.each(function () {
                void 0 !== t(this).data('origStyle')
                  ? t(this).attr('style', t(this).data('origStyle'))
                  : t(this).removeAttr('style');
              }),
              void 0 !== t(this).data('origStyle')
                ? this.attr('style', t(this).data('origStyle'))
                : t(this).removeAttr('style'),
              t(this).unwrap().unwrap(),
              s.controls.el && s.controls.el.remove(),
              s.controls.next && s.controls.next.remove(),
              s.controls.prev && s.controls.prev.remove(),
              s.pagerEl &&
              s.settings.controls &&
              !s.settings.pagerCustom &&
              s.pagerEl.remove(),
              t('.bx-caption', this).remove(),
              s.controls.autoEl && s.controls.autoEl.remove(),
              clearInterval(s.interval),
              s.settings.responsive && t(window).unbind('resize', Z),
              s.settings.keyboardEnabled && t(document).unbind('keydown', F),
              t(this).removeData('bxSlider'));
        }),
        (o.reloadSlider = function (e) {
          void 0 !== e && (n = e),
            o.destroySlider(),
            l(),
            t(o).data('bxSlider', this);
        }),
        l(),
        t(o).data('bxSlider', this),
        this
      );
    }
  };
})(jQuery);

//countdown
!(function (a) {
  'use strict';
  'function' == typeof define && define.amd ? define(['jquery'], a) : a(jQuery);
})(function (a) {
  'use strict';
  function b(a) {
    if (a instanceof Date) return a;
    if (String(a).match(g))
      return (
        String(a).match(/^[0-9]*$/) && (a = Number(a)),
        String(a).match(/\-/) && (a = String(a).replace(/\-/g, '/')),
        new Date(a)
      );
    throw new Error("Couldn't cast `" + a + '` to a date object.');
  }
  function c(a) {
    var b = a.toString().replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    return new RegExp(b);
  }
  function d(a) {
    return function (b) {
      var d = b.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
      if (d)
        for (var f = 0, g = d.length; f < g; ++f) {
          var h = d[f].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),
            j = c(h[0]),
            k = h[1] || '',
            l = h[3] || '',
            m = null;
          (h = h[2]),
            i.hasOwnProperty(h) && ((m = i[h]), (m = Number(a[m]))),
            null !== m &&
            ('!' === k && (m = e(l, m)),
              '' === k && m < 10 && (m = '0' + m.toString()),
              (b = b.replace(j, m.toString())));
        }
      return (b = b.replace(/%%/, '%'));
    };
  }
  function e(a, b) {
    var c = 's',
      d = '';
    return (
      a &&
      ((a = a.replace(/(:|;|\s)/gi, '').split(/\,/)),
        1 === a.length ? (c = a[0]) : ((d = a[0]), (c = a[1]))),
      Math.abs(b) > 1 ? c : d
    );
  }
  var f = [],
    g = [],
    h = { precision: 100, elapse: !1, defer: !1 };
  g.push(/^[0-9]*$/.source),
    g.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),
    g.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),
    (g = new RegExp(g.join('|')));
  var i = {
    Y: 'years',
    m: 'months',
    n: 'daysToMonth',
    d: 'daysToWeek',
    w: 'weeks',
    W: 'weeksToMonth',
    H: 'hours',
    M: 'minutes',
    S: 'seconds',
    D: 'totalDays',
    I: 'totalHours',
    N: 'totalMinutes',
    T: 'totalSeconds',
  },
    j = function (b, c, d) {
      (this.el = b),
        (this.$el = a(b)),
        (this.interval = null),
        (this.offset = {}),
        (this.options = a.extend({}, h)),
        (this.firstTick = !0),
        (this.instanceNumber = f.length),
        f.push(this),
        this.$el.data('countdown-instance', this.instanceNumber),
        d &&
        ('function' == typeof d
          ? (this.$el.on('update.countdown', d),
            this.$el.on('stoped.countdown', d),
            this.$el.on('finish.countdown', d))
          : (this.options = a.extend({}, h, d))),
        this.setFinalDate(c),
        this.options.defer === !1 && this.start();
    };
  a.extend(j.prototype, {
    start: function () {
      null !== this.interval && clearInterval(this.interval);
      var a = this;
      this.update(),
        (this.interval = setInterval(function () {
          a.update.call(a);
        }, this.options.precision));
    },
    stop: function () {
      clearInterval(this.interval),
        (this.interval = null),
        this.dispatchEvent('stoped');
    },
    toggle: function () {
      this.interval ? this.stop() : this.start();
    },
    pause: function () {
      this.stop();
    },
    resume: function () {
      this.start();
    },
    remove: function () {
      this.stop.call(this),
        (f[this.instanceNumber] = null),
        delete this.$el.data().countdownInstance;
    },
    setFinalDate: function (a) {
      this.finalDate = b(a);
    },
    update: function () {
      if (0 === this.$el.closest('html').length) return void this.remove();
      var a,
        b = new Date();
      return (
        (a = this.finalDate.getTime() - b.getTime()),
        (a = Math.ceil(a / 1e3)),
        (a = !this.options.elapse && a < 0 ? 0 : Math.abs(a)),
        this.totalSecsLeft === a || this.firstTick
          ? void (this.firstTick = !1)
          : ((this.totalSecsLeft = a),
            (this.elapsed = b >= this.finalDate),
            (this.offset = {
              seconds: this.totalSecsLeft % 60,
              minutes: Math.floor(this.totalSecsLeft / 60) % 60,
              hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
              days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
              daysToWeek: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
              daysToMonth: Math.floor(
                (this.totalSecsLeft / 60 / 60 / 24) % 30.4368
              ),
              weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
              weeksToMonth:
                Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7) % 4,
              months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30.4368),
              years: Math.abs(this.finalDate.getFullYear() - b.getFullYear()),
              totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
              totalHours: Math.floor(this.totalSecsLeft / 60 / 60),
              totalMinutes: Math.floor(this.totalSecsLeft / 60),
              totalSeconds: this.totalSecsLeft,
            }),
            void (this.options.elapse || 0 !== this.totalSecsLeft
              ? this.dispatchEvent('update')
              : (this.stop(), this.dispatchEvent('finish'))))
      );
    },
    dispatchEvent: function (b) {
      var c = a.Event(b + '.countdown');
      (c.finalDate = this.finalDate),
        (c.elapsed = this.elapsed),
        (c.offset = a.extend({}, this.offset)),
        (c.strftime = d(this.offset)),
        this.$el.trigger(c);
    },
  }),
    (a.fn.countdown = function () {
      var b = Array.prototype.slice.call(arguments, 0);
      return this.each(function () {
        var c = a(this).data('countdown-instance');
        if (void 0 !== c) {
          var d = f[c],
            e = b[0];
          j.prototype.hasOwnProperty(e)
            ? d[e].apply(d, b.slice(1))
            : null === String(e).match(/^[$A-Z_][0-9A-Z_$]*$/i)
              ? (d.setFinalDate.call(d, e), d.start())
              : a.error(
                'Method %s does not exist on jQuery.countdown'.replace(
                  /\%s/gi,
                  e
                )
              );
        } else new j(this, b[0], b[1]);
      });
    });
});

//notify.js
!(function (t) {
  'function' == typeof define && define.amd
    ? define(['jquery'], t)
    : t('object' == typeof exports ? require('jquery') : jQuery);
})(function (t) {
  function s(s) {
    var e = !1;
    return (
      t('[data-notify="container"]').each(function (i, n) {
        var a = t(n),
          o = a.find('[data-notify="title"]').text().trim(),
          r = a.find('[data-notify="message"]').html().trim(),
          l =
            o ===
            t('<div>' + s.settings.content.title + '</div>')
              .html()
              .trim(),
          d =
            r ===
            t('<div>' + s.settings.content.message + '</div>')
              .html()
              .trim(),
          g = a.hasClass('alert-' + s.settings.type);
        return l && d && g && (e = !0), !e;
      }),
      e
    );
  }
  function e(e, n, a) {
    var o = {
      content: {
        message: 'object' == typeof n ? n.message : n,
        title: n.title ? n.title : '',
        icon: n.icon ? n.icon : '',
        url: n.url ? n.url : '#',
        target: n.target ? n.target : '-',
      },
    };
    (a = t.extend(!0, {}, o, a)),
      (this.settings = t.extend(!0, {}, i, a)),
      (this._defaults = i),
      '-' === this.settings.content.target &&
      (this.settings.content.target = this.settings.url_target),
      (this.animations = {
        start:
          'webkitAnimationStart oanimationstart MSAnimationStart animationstart',
        end: 'webkitAnimationEnd oanimationend MSAnimationEnd animationend',
      }),
      'number' == typeof this.settings.offset &&
      (this.settings.offset = {
        x: this.settings.offset,
        y: this.settings.offset,
      }),
      (this.settings.allow_duplicates ||
        (!this.settings.allow_duplicates && !s(this))) &&
      this.init();
  }
  var i = {
    element: 'body',
    position: null,
    type: 'info',
    allow_dismiss: !0,
    allow_duplicates: !0,
    newest_on_top: !1,
    showProgressbar: !1,
    placement: { from: 'top', align: 'right' },
    offset: 20,
    spacing: 10,
    z_index: 1031,
    delay: 5e3,
    timer: 1e3,
    url_target: '_blank',
    mouse_over: null,
    animate: { enter: 'animated fadeInDown', exit: 'animated fadeOutUp' },
    onShow: null,
    onShown: null,
    onClose: null,
    onClosed: null,
    icon_type: 'class',
    template:
      '<div data-notify="container" class="col-xs-11 col-sm-4 alert alert-{0}" role="alert"><button type="button" aria-hidden="true" class="close" data-notify="dismiss">&times;</button><span data-notify="icon"></span> <span data-notify="title">{1}</span> <span data-notify="message">{2}</span><div class="progress" data-notify="progressbar"><div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div><a href="{3}" target="{4}" data-notify="url"></a></div>',
  };
  (String.format = function () {
    for (var t = arguments[0], s = 1; s < arguments.length; s++)
      t = t.replace(RegExp('\\{' + (s - 1) + '\\}', 'gm'), arguments[s]);
    return t;
  }),
    t.extend(e.prototype, {
      init: function () {
        var t = this;
        this.buildNotify(),
          this.settings.content.icon && this.setIcon(),
          '#' != this.settings.content.url && this.styleURL(),
          this.styleDismiss(),
          this.placement(),
          this.bind(),
          (this.notify = {
            $ele: this.$ele,
            update: function (s, e) {
              var i = {};
              'string' == typeof s ? (i[s] = e) : (i = s);
              for (var n in i)
                switch (n) {
                  case 'type':
                    this.$ele.removeClass('alert-' + t.settings.type),
                      this.$ele
                        .find('[data-notify="progressbar"] > .progress-bar')
                        .removeClass('progress-bar-' + t.settings.type),
                      (t.settings.type = i[n]),
                      this.$ele
                        .addClass('alert-' + i[n])
                        .find('[data-notify="progressbar"] > .progress-bar')
                        .addClass('progress-bar-' + i[n]);
                    break;
                  case 'icon':
                    var a = this.$ele.find('[data-notify="icon"]');
                    'class' === t.settings.icon_type.toLowerCase()
                      ? a.removeClass(t.settings.content.icon).addClass(i[n])
                      : (a.is('img') || a.find('img'), a.attr('src', i[n]));
                    break;
                  case 'progress':
                    var o = t.settings.delay - t.settings.delay * (i[n] / 100);
                    this.$ele.data('notify-delay', o),
                      this.$ele
                        .find('[data-notify="progressbar"] > div')
                        .attr('aria-valuenow', i[n])
                        .css('width', i[n] + '%');
                    break;
                  case 'url':
                    this.$ele.find('[data-notify="url"]').attr('href', i[n]);
                    break;
                  case 'target':
                    this.$ele.find('[data-notify="url"]').attr('target', i[n]);
                    break;
                  default:
                    this.$ele.find('[data-notify="' + n + '"]').html(i[n]);
                }
              var r =
                this.$ele.outerHeight() +
                parseInt(t.settings.spacing) +
                parseInt(t.settings.offset.y);
              t.reposition(r);
            },
            close: function () {
              t.close();
            },
          });
      },
      buildNotify: function () {
        var s = this.settings.content;
        (this.$ele = t(
          String.format(
            this.settings.template,
            this.settings.type,
            s.title,
            s.message,
            s.url,
            s.target
          )
        )),
          this.$ele.attr(
            'data-notify-position',
            this.settings.placement.from + '-' + this.settings.placement.align
          ),
          this.settings.allow_dismiss ||
          this.$ele.find('[data-notify="dismiss"]').css('display', 'none'),
          ((this.settings.delay <= 0 && !this.settings.showProgressbar) ||
            !this.settings.showProgressbar) &&
          this.$ele.find('[data-notify="progressbar"]').remove();
      },
      setIcon: function () {
        'class' === this.settings.icon_type.toLowerCase()
          ? this.$ele
            .find('[data-notify="icon"]')
            .addClass(this.settings.content.icon)
          : this.$ele.find('[data-notify="icon"]').is('img')
            ? this.$ele
              .find('[data-notify="icon"]')
              .attr('src', this.settings.content.icon)
            : this.$ele
              .find('[data-notify="icon"]')
              .append(
                '<img loading="lazy" src="' +
                this.settings.content.icon +
                '" alt="Notify Icon" />'
              );
      },
      styleDismiss: function () {
        this.$ele.find('[data-notify="dismiss"]').css({
          position: 'absolute',
          right: '10px',
          top: '5px',
          zIndex: this.settings.z_index + 2,
        });
      },
      styleURL: function () {
        this.$ele.find('[data-notify="url"]').css({
          backgroundImage:
            'url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)',
          height: '100%',
          left: 0,
          position: 'absolute',
          top: 0,
          width: '100%',
          zIndex: this.settings.z_index + 1,
        });
      },
      placement: function () {
        var s = this,
          e = this.settings.offset.y,
          i = {
            display: 'inline-block',
            margin: '0px auto',
            position: this.settings.position
              ? this.settings.position
              : 'body' === this.settings.element
                ? 'fixed'
                : 'absolute',
            transition: 'all .5s ease-in-out',
            zIndex: this.settings.z_index,
          },
          n = !1,
          a = this.settings;
        switch (
        (t(
          '[data-notify-position="' +
          this.settings.placement.from +
          '-' +
          this.settings.placement.align +
          '"]:not([data-closing="true"])'
        ).each(function () {
          e = Math.max(
            e,
            parseInt(t(this).css(a.placement.from)) +
            parseInt(t(this).outerHeight()) +
            parseInt(a.spacing)
          );
        }),
          this.settings.newest_on_top === !0 && (e = this.settings.offset.y),
          (i[this.settings.placement.from] = e + 'px'),
          this.settings.placement.align)
        ) {
          case 'left':
          case 'right':
            i[this.settings.placement.align] = this.settings.offset.x + 'px';
            break;
          case 'center':
            (i.left = 0), (i.right = 0);
        }
        this.$ele.css(i).addClass(this.settings.animate.enter),
          t.each(Array('webkit-', 'moz-', 'o-', 'ms-', ''), function (t, e) {
            s.$ele[0].style[e + 'AnimationIterationCount'] = 1;
          }),
          t(this.settings.element).append(this.$ele),
          this.settings.newest_on_top === !0 &&
          ((e =
            parseInt(e) +
            parseInt(this.settings.spacing) +
            this.$ele.outerHeight()),
            this.reposition(e)),
          t.isFunction(s.settings.onShow) && s.settings.onShow.call(this.$ele),
          this.$ele
            .one(this.animations.start, function () {
              n = !0;
            })
            .one(this.animations.end, function () {
              s.$ele.removeClass(s.settings.animate.enter),
                t.isFunction(s.settings.onShown) &&
                s.settings.onShown.call(this);
            }),
          setTimeout(function () {
            n ||
              (t.isFunction(s.settings.onShown) &&
                s.settings.onShown.call(this));
          }, 600);
      },
      bind: function () {
        var s = this;
        if (
          (this.$ele.find('[data-notify="dismiss"]').on('click', function () {
            s.close();
          }),
            this.$ele
              .mouseover(function () {
                t(this).data('data-hover', 'true');
              })
              .mouseout(function () {
                t(this).data('data-hover', 'false');
              }),
            this.$ele.data('data-hover', 'false'),
            this.settings.delay > 0)
        ) {
          s.$ele.data('notify-delay', s.settings.delay);
          var e = setInterval(function () {
            var t = parseInt(s.$ele.data('notify-delay')) - s.settings.timer;
            if (
              ('false' === s.$ele.data('data-hover') &&
                'pause' === s.settings.mouse_over) ||
              'pause' != s.settings.mouse_over
            ) {
              var i = ((s.settings.delay - t) / s.settings.delay) * 100;
              s.$ele.data('notify-delay', t),
                s.$ele
                  .find('[data-notify="progressbar"] > div')
                  .attr('aria-valuenow', i)
                  .css('width', i + '%');
            }
            t <= -s.settings.timer && (clearInterval(e), s.close());
          }, s.settings.timer);
        }
      },
      close: function () {
        var s = this,
          e = parseInt(this.$ele.css(this.settings.placement.from)),
          i = !1;
        this.$ele
          .attr('data-closing', 'true')
          .addClass(this.settings.animate.exit),
          s.reposition(e),
          t.isFunction(s.settings.onClose) &&
          s.settings.onClose.call(this.$ele),
          this.$ele
            .one(this.animations.start, function () {
              i = !0;
            })
            .one(this.animations.end, function () {
              t(this).remove(),
                t.isFunction(s.settings.onClosed) &&
                s.settings.onClosed.call(this);
            }),
          setTimeout(function () {
            i ||
              (s.$ele.remove(),
                s.settings.onClosed && s.settings.onClosed(s.$ele));
          }, 600);
      },
      reposition: function (s) {
        var e = this,
          i =
            '[data-notify-position="' +
            this.settings.placement.from +
            '-' +
            this.settings.placement.align +
            '"]:not([data-closing="true"])',
          n = this.$ele.nextAll(i);
        this.settings.newest_on_top === !0 && (n = this.$ele.prevAll(i)),
          n.each(function () {
            t(this).css(e.settings.placement.from, s),
              (s =
                parseInt(s) +
                parseInt(e.settings.spacing) +
                t(this).outerHeight());
          });
      },
    }),
    (t.notify = function (t, s) {
      var i = new e(this, t, s);
      return i.notify;
    }),
    (t.notifyDefaults = function (s) {
      return (i = t.extend(!0, {}, i, s));
    }),
    (t.notifyClose = function (s) {
      'warning' === s && (s = 'danger'),
        'undefined' == typeof s || 'all' === s
          ? t('[data-notify]').find('[data-notify="dismiss"]').trigger('click')
          : 'success' === s || 'info' === s || 'warning' === s || 'danger' === s
            ? t('.alert-' + s + '[data-notify]')
              .find('[data-notify="dismiss"]')
              .trigger('click')
            : s
              ? t(s + '[data-notify]')
                .find('[data-notify="dismiss"]')
                .trigger('click')
              : t('[data-notify-position="' + s + '"]')
                .find('[data-notify="dismiss"]')
                .trigger('click');
    }),
    (t.notifyCloseExcept = function (s) {
      'warning' === s && (s = 'danger'),
        'success' === s || 'info' === s || 'warning' === s || 'danger' === s
          ? t('[data-notify]')
            .not('.alert-' + s)
            .find('[data-notify="dismiss"]')
            .trigger('click')
          : t('[data-notify]')
            .not(s)
            .find('[data-notify="dismiss"]')
            .trigger('click');
    });
});

document.addEventListener('DOMContentLoaded', (event) => {
  // BinderPOS Loaders
  // TODO remove oldbuylist
  var buylistItems = document.body.querySelectorAll('*[href="#buylist"]');
  buylistItems.forEach(function (buylistItem) {
    buylistItem.addEventListener('click', function (e) {
      e.preventDefault();
      buildBuylistOverlay();
    });
  });

  var decklistItems = document.body.querySelectorAll('*[href="#decklist"]');
  decklistItems.forEach(function (decklistItem) {
    decklistItem.addEventListener('click', function (e) {
      e.preventDefault();
      showDecklist();
    });
  });
});

//BinderPOS Helper Functions
function text_truncate(str, length, ending) {
  if (length == null) {
    length = 100;
  }
  if (ending == null) {
    ending = '...';
  }
  if (str.length > length) {
    return str.substring(0, length - ending.length) + ending;
  } else {
    return str;
  }
}

//Buylist
var overlayStyle =
  'position: fixed; top: 0; right: 0; z-index: 999999999; width: 85%; height: 100%; background: rgba(0,0,0,0.75);';
var iframeDivStyle =
  'text-align: center; position: absolute; width: 100%; height: 100%;';
var closeStyle =
  'color:white; position: absolute; top: 8px; left: 3px; height: 3rem; width:3rem; cursor: pointer; font-size: 22px';

function buylistIsInstalled() {
  return (
    window.binderPOSBuylist &&
    window.binderPOSBuylist.portalUrl &&
    window.binderPOSBuylist.portalUrl.length > 0
  );
}

function buildBuylistOverlay() {
  var currentOverlay = document.querySelector('binderpos-buylist-overlay');
  if (!currentOverlay && buylistIsInstalled()) {
    var buylistOverlay = document.createElement('div');
    buylistOverlay.id = 'binderpos-buylist-overlay';
    buylistOverlay.setAttribute('style', overlayStyle);

    buylistOverlay.addEventListener('click', (e) => {
      if (e.target == buylistOverlay) {
        removeElement(buylistOverlay);
      }
    });

    var iframeContainer = document.createElement('div');
    iframeContainer.id = 'binderpos-buylist-iframe-container';
    iframeContainer.setAttribute('style', iframeDivStyle);

    iframeContainer.addEventListener('click', (e) => {
      if (e.target == iframeContainer) {
        removeElement(buylistOverlay);
      }
    });

    var iframeClose = document.createElement('div');
    iframeClose.setAttribute('style', closeStyle);

    var iframeIcon = document.createElement('i');
    iframeIcon.className = 'fa fa-times-circle';
    iframeClose.appendChild(iframeIcon);

    iframeClose.addEventListener('click', (e) => {
      if (e.target == iframeClose || e.target == iframeIcon) {
        removeElement(buylistOverlay);
      }
    });

    iframeContainer.appendChild(iframeClose);

    var iframeContent = document.createElement('iframe');
    iframeContent.className = 'binderpos-buylist-iframe';
    iframeContent.setAttribute(
      'style',
      'width: 1px !important; min-width: 100%;'
    );
    iframeContent.setAttribute('height', '100%');
    iframeContent.setAttribute('scrolling', 'no');
    iframeContent.setAttribute('frameborder', 0);
    iframeContent.setAttribute('allowfullscreen', 'true');
    iframeContent.src = window.binderPOSBuylist.portalUrl;

    iframeContainer.appendChild(iframeContent);

    buylistOverlay.appendChild(iframeContainer);

    document.body.appendChild(buylistOverlay);
  } else {
    console.log('Buylist not installed');
  }

  function removeElement(node) {
    node.parentNode.removeChild(node);
  }
}

//Decklist
//show Decklist

function showDecklist(oldSearch, auto) {
  const documentBody = document.body;
  const deckListBody = document.querySelector('#deckListBody');
  const overlay = document.querySelector('#decklistOpened');
  const closeBtn = document.querySelector('#decklist-close-button');
  const actionBtn = document.querySelector('#decklistAction button');
  const topBar = document.querySelector('.decklist-top-bar');
  const selectDropdown = document.querySelector('#gameType');

  const textareaPlaceholderWrapper = document.createElement('div');
  const placeholderImg = document.createElement('img');
  const placeholderText = document.createElement('span');
  const textarea = document.createElement('textarea');

  documentBody.classList.add('noscroll');
  overlay.classList.remove('hide');
  textareaPlaceholderWrapper.className = 'textImgWrapper';
  textarea.id = 'deck-builder';

  actionBtn.onclick = processDeckList;
  placeholderImg.src =
    'https://storage.googleapis.com/binderpos-libraries/buylistCards.png';
  placeholderText.innerHTML =
    'Paste your decklist here using MTGGoldfish format <br><br>Example<br>------------------<br>3 Beanstalk Giant<br>  4 Fae of Wishes<br>   3 Hydroid Krasis<br>   4 Golos, Tireless Pilgrim<br>  2 Kenrith, the Returned King<br>   2 Forest';

  textareaPlaceholderWrapper.appendChild(placeholderImg);
  textareaPlaceholderWrapper.appendChild(placeholderText);
  deckListBody.classList.remove('list-view');
  deckListBody.appendChild(textareaPlaceholderWrapper);
  deckListBody.appendChild(textarea);

  overlay.addEventListener('click', function (e) {
    if (e.target == overlay || e.target == closeBtn) {
      overlay.classList.add('hide');
      deckListBody.innerHTML = '';
      topBar.removeChild(select);
      actionBtn.innerHTML = 'Submit deck list';
      documentBody.classList.remove('noscroll');
    }
  });

  textarea.addEventListener('input', () => {
    const textLn = textarea.value.length;
    if (textLn >= 1) {
      textareaPlaceholderWrapper.style.zIndex = '-1';
    } else {
      textareaPlaceholderWrapper.style.zIndex = '0';
    }
  });

  if (!topBar.contains(selectDropdown)) {
    const select = document.createElement('select');
    select.id = 'gameType';
    topBar.appendChild(select);

    $.ajax({
      url:
        'https://portal.binderpos.com/external/shopify/supportedGames?storeUrl=' +
        theme.permanentDomain,
      type: 'GET',
      dataType: 'json',
      success: function (games) {
        games.forEach((game) => {
          if (game.gameName) {
            const opt = document.createElement('option');
            opt.appendChild(
              document.createTextNode(game.gameName.substring(0, 24))
            );
            opt.value = game.gameId;
            if (game.gameId == 'mtg') {
              opt.selected = true;
            }
            select.appendChild(opt);
          }
        });
      },
    });
  } else {
    const backBtn = document.querySelector('.backBtn');
    selectDropdown.classList.remove('hide');
    topBar.removeChild(backBtn);
  }

  if (oldSearch) {
    actionBtn.innerHTML = 'Submit deck list';
    deckListBody.innerHTML = '';
    textarea.value = oldSearch;
    deckListBody.appendChild(textareaPlaceholderWrapper);
    deckListBody.appendChild(textarea);
    if (textarea.value.length > 0) {
      textareaPlaceholderWrapper.style.zIndex = '-1';
    } else {
      textareaPlaceholderWrapper.style.zIndex = '0';
    }
  }
  if (auto) {
    textarea.style.background = 'white';
    textarea.innerHTML = auto.join('\r\n').replace(/\//gm, ' // ');
    processDeckList();
  }
}

// Process Deck List
function processDeckList() {
  var backData = $('#deck-builder').val();
  var deckList = $('#deck-builder').val().split('\n');
  var deckBody = document.querySelector('#deckListBody');
  var loader = document.querySelector('#savedLoader');
  var type = 'mtg';
  var gameSelector = document.querySelector('#gameType');
  gameSelector.classList.add('hide');
  if (gameSelector) {
    type = document.querySelector('#gameType option:checked').value;
  }
  deckBody.innerHTML = loader.innerHTML;
  deckList = parseDeckList(deckList);
  return $.ajax({
    url:
      'https://portal.binderpos.com/external/shopify/decklist?storeUrl=' +
      theme.permanentDomain +
      '&type=' +
      type,
    type: 'POST',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    data: JSON.stringify(deckList),
    success: function (result) {
      var backBtn = document.createElement('span');
      const topBar = document.querySelector('.decklist-top-bar');
      deckBody.classList.add('list-view');
      deckBody.innerHTML = '';
      backBtn.className = 'backBtn';
      backBtn.innerHTML =
        "<i class='fas fa-long-arrow-alt-left'></i> Re-enter list";
      backBtn.addEventListener('click', function () {
        showDecklist(backData);
      });
      topBar.appendChild(backBtn);
      var decklistBtnAction = document.querySelector('#decklistAction button');
      decklistBtnAction.innerHTML = 'Add selected cards to cart';
      decklistBtnAction.onclick = compileDeckList;
      var decklistActions = document.createElement('div');
      decklistActions.className = 'decklistActions';
      var checkboxallLabel = document.createElement('label');
      checkboxallLabel.className = 'checkbox';
      var checkboxallInput = document.createElement('input');
      checkboxallInput.type = 'checkbox';
      checkboxallInput.onclick = toggleall;
      checkboxallInput.checked = true;
      var checkboxallSpan = document.createElement('span');
      checkboxallSpan.className = 'checkmark';
      var labelText = document.createElement('p');
      labelText.innerHTML = 'Select all';
      checkboxallLabel.appendChild(checkboxallInput);
      checkboxallLabel.appendChild(checkboxallSpan);
      checkboxallLabel.appendChild(labelText);
      var totals = document.createElement('div');
      totals.className = 'totals';
      totals.innerHTML = 'Total:';
      var totalAmount = document.createElement('em');
      totalAmount.className = 'totalAmmount';
      totalAmount.innerHTML = Shopify.formatMoney(
        0,
        window.theme.moneyWithCurrencyFormat
      );
      totals.appendChild(totalAmount);
      decklistActions.appendChild(checkboxallLabel);
      decklistActions.appendChild(totals);
      deckBody.appendChild(decklistActions);
      var notFoundList = [];
      result.forEach(function (resultLine) {
        if (resultLine.found == 0) {
          notFoundList.push(resultLine);
        }
        var options;
        if (resultLine.products.length > 0) {
          options = resultLine.products;
        }
        var added = 0;
        resultLine.products.forEach(function (item) {
          var requested = resultLine.requested;
          var avaialable = item.variants[0].quantity;
          if (added < requested) {
            var itemMax = 0;
            if (requested - added < avaialable) {
              itemMax = avaialable;
            } else {
              itemMax = avaialable;
            }
            if (avaialable > requested) {
              itemMax = requested - added;
            }
            added += avaialable;
            decklistItem(item, deckBody, itemMax, avaialable, options);
          }
        });
      });
      // Activate swap toggle
      swapToggle();
      toggleall();
      notFoundList.forEach(function (element) {
        noDeckListItem(
          deckBody,
          element.searchName,
          element.validName,
          element.imageUrl,
          element.requested
        );
      });
    },
    error: function (result) {
      console.log('Error below');
      console.log(result);
    },
  });
}
//Decklist No Stock & Failed Items
function noDeckListItem(deckBody, name, valid, imgUrl, requested) {
  var deckListItem = document.createElement('div');
  deckListItem.id = 'deckItem';
  if (valid == false) {
    deckListItem.style.background = '#efeeee';
  }
  deckListItem.className = 'decklistItem nostockAvail';
  deckBody.appendChild(deckListItem);
  var blank = document.createElement('div');
  deckListItem.appendChild(blank);
  var img = document.createElement('img');
  img.className = 'decklistImg';
  if (valid) {
    img.src = imgUrl;
  } else {
    img.src =
      'https://storage.googleapis.com/binderpos-libraries/cardNoImage.png';
  }
  deckListItem.appendChild(img);
  var ammountDiv = document.createElement('div');
  ammountDiv.className = 'required';
  var selectedAmmount = document.createElement('span');
  selectedAmmount.className = 'selectedAmount';
  selectedAmmount.innerHTML = '0';
  var requestedAmmount = document.createElement('span');
  requestedAmmount.className = 'requestedAmount';
  requestedAmmount.innerHTML = '/' + requested;
  ammountDiv.appendChild(selectedAmmount);
  ammountDiv.appendChild(requestedAmmount);
  deckListItem.appendChild(ammountDiv);
  var info = document.createElement('div');
  info.className = 'decklistTitleNoStock';
  info.innerHTML = text_truncate(name, 35, '...');
  deckListItem.appendChild(info);
  if (valid) {
    var price = document.createElement('div');
    price.className = 'linePrice';
    price.innerHTML = '?';
    deckListItem.appendChild(price);
    var noStock = document.createElement('div');
    noStock.className = 'noStock';
    noStock.innerHTML = 'No stock';
    deckListItem.appendChild(noStock);
  } else {
    var unknownCard = document.createElement('div');
    unknownCard.className = 'unknown';
    unknownCard.innerHTML = 'Unknown card';
    deckListItem.appendChild(unknownCard);
  }
}

//Decklist Line Items
function decklistItem(item, deckBody, itemMax, avaialable, options, swap) {
  var currentLine = item.variants[0];
  if (swap != 'true') {
    // New Item
    var deckListItem = document.createElement('div');
    deckListItem.id = 'deckItem' + currentLine.shopifyId;
    deckListItem.className = 'decklistItem';
    deckBody.appendChild(deckListItem);
  } else {
    // If item already exists, dont create a new div. Swap the details
    deckListItem = document.querySelector('#deckItem' + currentLine.shopifyId);
  }
  var checkboxLabel = document.createElement('label');
  checkboxLabel.className = 'checkbox';
  var checkboxInput = document.createElement('input');
  checkboxInput.type = 'checkbox';
  checkboxInput.onclick = toggleOne;
  var checkboxSpan = document.createElement('span');
  checkboxSpan.className = 'checkmark';
  checkboxLabel.appendChild(checkboxInput);
  checkboxLabel.appendChild(checkboxSpan);
  var img = document.createElement('img');
  img.className = 'decklistImg';
  img.src = item.img;
  var price = document.createElement('div');
  price.className = 'linePrice';
  price.setAttribute('data-price', currentLine.price);
  price.innerHTML = Shopify.formatMoney(
    currentLine.price * 100,
    window.theme.moneyWithCurrencyFormat
  );
  if (options.length == 1) {
    price.style.marginLeft = '16px';
  }
  var ammountDiv = document.createElement('div');
  ammountDiv.className = 'required';
  var selectedAmmount = document.createElement('span');
  selectedAmmount.className = 'selectedAmount';
  selectedAmmount.innerHTML = itemMax;
  var requestedAmmount = document.createElement('span');
  requestedAmmount.className = 'requestedAmount';
  requestedAmmount.innerHTML = '/' + itemMax;
  ammountDiv.appendChild(selectedAmmount);
  ammountDiv.appendChild(requestedAmmount);
  var info = document.createElement('div');
  info.className = 'decklistTitle';
  var cardName = item.name;
  info.innerHTML =
    text_truncate(cardName, 35, '...') +
    "<br> <em class='setName'>" +
    text_truncate(item.setName, 35, '...') +
    '</em><br><em>- ' +
    currentLine.title +
    '</em>';
  var qtyWrapper = document.createElement('div');
  qtyWrapper.className = 'qtyWrapper';
  var addAmount = document.createElement('input');
  addAmount.type = 'number';
  addAmount.min = '0';
  addAmount.max = avaialable;
  addAmount.value = itemMax;
  addAmount.addEventListener('change', function () {
    decklistQty(currentLine.shopifyId);
  });
  var plusBtn = document.createElement('span');
  plusBtn.className = 'addQty';
  plusBtn.innerHTML = '+';
  var minusBtn = document.createElement('span');
  minusBtn.className = 'minusQty';
  minusBtn.innerHTML = '-';
  plusBtn.addEventListener('click', function () {
    decklistQty(currentLine.shopifyId, 'add');
  });
  minusBtn.addEventListener('click', function () {
    decklistQty(currentLine.shopifyId, 'remove');
  });
  deckListItem.appendChild(checkboxLabel);
  deckListItem.appendChild(img);
  deckListItem.appendChild(ammountDiv);
  deckListItem.appendChild(info);
  // If other Card Options then show switcher
  if (options.length > 1) {
    var swapIcon = document.createElement('i');
    swapIcon.className = 'fas fa-exchange-alt';
    deckListItem.appendChild(swapIcon);
    // Add event listener to new replaced Item
    if (swap == 'true') {
      swapIcon.addEventListener('click', function (e) {
        var lineItem = e.target.parentNode;
        var menuDiv = lineItem.querySelector('.optionsWrapper');
        if (menuDiv.style.display == 'block') {
          menuDiv.style.display = 'none';
        } else {
          menuDiv.style.display = 'block';
        }
      });
    }
    var optionsDiv = document.createElement('div');
    optionsDiv.className = 'optionsWrapper';
    var headerLine = document.createElement('div');
    headerLine.className = 'optionsHeaders';
    headerLine.innerHTML =
      "<div class='optionTitle'><div>Card Title</div><div>Condtion</div><div>Price</div><div>Availability</div></div>";
    optionsDiv.appendChild(headerLine);
    options.forEach(function (element) {
      // Show card options that not the Current or curent cpndtion
      if (element.name != item.name) {
        var optionLine = document.createElement('div');
        optionLine.id = 'option-' + element.shopifyId;
        var fullName = element.name + ' [' + element.setName + ']';
        optionLine.innerHTML =
          "<div class='optionStyle'><div class='cardFields'><div>" +
          text_truncate(fullName, 37, '...') +
          '</div><div>' +
          element.variants[0].title +
          '</div><div>' +
          Shopify.formatMoney(
            element.variants[0].price * 100,
            window.theme.moneyWithCurrencyFormat
          ) +
          '</div><div>' +
          element.variants[0].quantity +
          '  in Stock</div></div></div>';
        optionsDiv.appendChild(optionLine);
        optionLine.addEventListener('click', function () {
          swapLineItem(currentLine.shopifyId, element, itemMax, options);
        });
      } else if (element.variants[0].title != currentLine.title) {
        // If set did match, show other conditions available.
        var optionLine = document.createElement('div');
        optionLine.id = 'option-' + element.shopifyId;
        optionLine.innerHTML =
          "<div class='optionStyle'><div class='cardFields'><div>" +
          element.name +
          ' [' +
          element.setName +
          ']</div><div>' +
          element.variants[0].title +
          '</div><div>' +
          Shopify.formatMoney(
            element.variants[0].price * 100,
            window.theme.moneyWithCurrencyFormat
          ) +
          '</div><div>' +
          element.variants[0].quantity +
          '  in Stock</div></div></div>';
        optionsDiv.appendChild(optionLine);
        optionLine.addEventListener('click', function () {
          swapLineItem(currentLine.shopifyId, element, itemMax, options);
        });
      }
    });
    deckListItem.appendChild(optionsDiv);
  }
  deckListItem.appendChild(price);
  deckListItem.appendChild(qtyWrapper);
  qtyWrapper.appendChild(minusBtn);
  qtyWrapper.appendChild(addAmount);
  qtyWrapper.appendChild(plusBtn);
  if (itemMax == avaialable) {
    plusBtn.classList.add('maxed');
  }
}

//Swap Decklist Items menu toggle
function swapToggle() {
  var list = [];
  list = document.querySelectorAll('.fa-exchange-alt');
  if (list) {
    list.forEach(function (element) {
      element.addEventListener('click', function (e) {
        var lineItem = e.target.parentNode;
        var menuDiv = lineItem.querySelector('.optionsWrapper');
        if (menuDiv.style.display == 'block') {
          menuDiv.style.display = 'none';
        } else {
          menuDiv.style.display = 'block';
        }
      });
    });
  }
}
//Swap Decklist items
function swapLineItem(oldLineId, newLineData, requestQty, options) {
  var deckBody = document.querySelector('#deckListBody');
  var oldDiv = document.querySelector('#deckItem' + oldLineId);
  var state = document.querySelector('.decklistActions input');
  oldDiv.id = 'deckItem' + newLineData.variants[0].shopifyId;
  oldDiv.innerHTML = '';
  state.checked = false;
  decklistTotals();
  decklistItem(
    newLineData,
    deckBody,
    requestQty,
    newLineData.variants[0].quantity,
    options,
    'true'
  );
}

// Parse Decklist
function parseDeckList(list) {
  var result = [];
  var i = 0;
  for (i = 0; i < list.length; i++) {
    if (
      list[i] &&
      !list[i].includes('Pokémon Trading Card Game Deck List') &&
      !list[i].includes('##') &&
      !list[i].includes('Total Cards')
    ) {
      var parsedLine = list[i].match(/([0-9]+) (.+)/);
      // Fix is Qty not inputted with decklist
      if (!parsedLine) {
        parsedLine = [null, 1, list[i]];
      }
      if (parsedLine) {
        const regex1 = /(\d+)(?!.*\d+)/g;
        const regex2 = /(.[A-z]+.)(?!.*[A-z]+)/g;
        if (list[0].includes('Pokémon Trading Card Game Deck List')) {
          result.push({
            card: parsedLine[2]
              .replace(regex1, '')
              .replaceAll("'", '')
              .replaceAll('&', 'and')
              .replace('-GX', ' GX')
              .replace('PR-', '')
              .replace(regex2, ''),
            quantity: parsedLine[1],
          });
        } else {
          result.push({ card: parsedLine[2], quantity: parsedLine[1] });
        }
      }
    }
  }
  return result;
}

function decklistTotals() {
  var total = document.querySelector('.totals em');
  var list = document.querySelectorAll('.decklistItem input:checked');
  var parentlist = [];
  for (var i = 0; i < list.length; i++) {
    parentlist.push(
      list[i].parentNode.parentNode
        .querySelector('.linePrice')
        .getAttribute('data-price') *
      list[i].parentNode.parentNode.querySelector('input[type="number"]')
        .value
    );
  }
  var sum = 0;
  for (var i = 0; i < parentlist.length; i++) {
    sum += parentlist[i];
  }
  total.innerHTML = Shopify.formatMoney(
    sum * 100,
    window.theme.moneyWithCurrencyFormat
  );
}

// Decklist Qty Change
function decklistQty(item, action) {
  var lineEdit = document
    .querySelector('#deckItem' + item)
    .querySelector('input[type="number"]');
  var selectedQty = document
    .querySelector('#deckItem' + item)
    .querySelector('.selectedAmount');
  var checkbox = document
    .querySelector('#deckItem' + item)
    .querySelector('input[type="checkbox"]');
  var plusBtn = document
    .querySelector('#deckItem' + item)
    .querySelector('.addQty');
  var minusBtn = document
    .querySelector('#deckItem' + item)
    .querySelector('.minusQty');
  var state = document.querySelector('.decklistActions input');
  var maxAvail = parseInt(lineEdit.max);
  var qty = parseInt(lineEdit.value);
  if (action == 'add') {
    qty = qty + 1;
    lineEdit.value = qty;
    minusBtn.classList.remove('maxed');
  }
  if (action == 'remove') {
    qty = qty - 1;
    lineEdit.value = qty;
    plusBtn.classList.remove('maxed');
  }
  if (qty >= maxAvail) {
    lineEdit.value = maxAvail;
    plusBtn.classList.add('maxed');
  }
  if (qty <= 0 || isNaN(qty)) {
    lineEdit.value = 0;
    checkbox.checked = false;
    minusBtn.classList.add('maxed');
    plusBtn.classList.remove('maxed');
    state.checked = false;
  }
  selectedQty.innerHTML = lineEdit.value;
  decklistTotals();
}
//Toggle Selectall
function toggleall() {
  var state = document.querySelector('.decklistActions input');
  var list = document.querySelectorAll('.decklistItem input');
  if (state.checked == true) {
    list.forEach(function (item) {
      item.checked = true;
    });
    decklistTotals();
  } else {
    list.forEach(function (item) {
      item.checked = false;
    });
    decklistTotals();
  }
}

function toggleOne() {
  var state = document.querySelector('.decklistActions input');
  state.checked = false;
  decklistTotals();
  var state = document.querySelector('.decklistActions input');
  if (state.checked == true) {
    state.checked = false;
  }
}

/// Compile / Build Array for processing
function compileDeckList() {
  var list = document.querySelectorAll('.decklistItem input:checked');
  var parentlist = [];
  for (var i = 0; i < list.length; i++) {
    parentlist.push({
      id: list[i].parentNode.parentNode.id.substr(8),
      quantity: list[i].parentNode.parentNode.querySelector(
        'input[type="number"]'
      ).value,
      properties: {},
    });
  }
  var deckBody = document.querySelector('#deckListBody');
  deckBody.classList.remove('list-view');
  var loader = document.querySelector('#savedLoader');
  deckBody.innerHTML = loader.innerHTML;
  var message = deckBody.querySelector('.custom-loader p');
  message.innerHTML = 'Processing... Please wait';
  addAllItems(parentlist);
}
// Process Deck List

function addAllItems(array) {
  var queue = [];
  for (var i = 0; i < array.length; i++) {
    queue.push(array[i]);
  }
  jQuery.post(
    '/cart/add.js',
    {
      items: queue,
    },
    function () {
      Toastify({
        text: 'Decklist items added to cart',
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: 'bottom', // `top` or `bottom`
        position: 'left', // `left`, `center` or `right`
        backgroundColor: '#eb7c00',
        stopOnFocus: true, // Prevents dismissing of toast on hover
      }).showToast();
      var decklistOverlay = document.querySelector('#decklistOpened');
      decklistOverlay.classList.add('hide');
      var loader = decklistOverlay.querySelector('.custom-loader');
      loader.parentNode.removeChild(loader);
      var buttonText = decklistOverlay.querySelector('#decklistAction button');
      buttonText.innerHTML = 'Submit deck list';
      var body = document.body;
      body.classList.remove('noscroll');
      adjustCartDropDown();
    },
    'json'
  );
}
